// Translation.ts

export type Language = 'EN' | 'FR' | 'ES';

type TranslationKeys = string; 

export const translations: Record<Language, Record<TranslationKeys, string>> = {

// export const translations = {
  
//  les traductions commenté dans ce composant sont traductions aui ont déja été mentionnés dans d'autres parties. 


  EN: {
    app_name: "Otenti",
    about: "About",
    sales: "Sales Pages",
    articles: "Articles",
    support: "Support",
    contact: "Contact",
    search: "Search",
    home: "Home",
    products: "Products",
    become_client: "Become Client",
    contact_us: "Contact Us",
    authentication: "Authentication",
    app_development: "App Development",
    security_consulting: "Security Consulting",
    user_training: "User Training",
    maintenance: "Maintenance",
    quick_links: "Quick Links",
    our_services: "Our Services",
    location: "City, Country",
    footer_description: "Your trusted partner for innovative, secure solutions.",
    all_rights_reserved: "All rights reserved",
    
    // Navbar and Footer translations (already existing)
    welcome: "Welcome",
    welcome_back: "We're delighted to see you again. Access all your authentication features.",
    features_title: "Features",
    features_subtitle: "Everything you need for authentication",
    cta_title: "Ready to get started?",
    cta_button: "Get Started",
    auth: "Secure Authentication",
    auth_desc: "Multi-factor authentication and advanced security protocols to protect your users.",
    users: "User Management",
    users_desc: "Comprehensive tools for managing user roles and permissions.",
    security: "Enterprise Security",
    security_desc: "Enterprise-grade security features and compliance standards.",
    logout_title: "Logout confirmation",
    logout_message: "Are you sure you want to log out of your account?",
    cancel: "Cancel",
    confirm: "Log off",
    success_title: "Successful disconnection",
    success_message: "You have been successfully disconnected.",
    admin_dashboard: "AdminDashboard",
    sign_in: "Sign In",
    logout: "Logout",
    
    // Hero Component
    title_part1: "Secure Authentication",
    title_part2: "for Modern Businesses",
    description: "Otenti provides enterprise-grade authentication services that help you secure your applications and manage user access effectively.",
    button: "Get Started",
    video_title: "Otenti Demo",
    video_description: "Watch how easily you can integrate our secure authentication system into your application.",
    video_error: "Your browser can't read this video",


  // Home Component
  go_to_dashboard: "Go to Dashboard",
  welcome_to_secure_authenticator: "Welcome to a more secure authenticator",
  authentication_authorization: "Authentication & Authorization",
  safely_use_otenti: "Safely use Otenti as your identity provider",
  define_access_level: "Define level of access to your application",
  identify_inactive_users: "Easily identified inactive users",
  identify_abused_authentications: "Easily identified abused authentications",
  learn_more: "Learn more",
  optimize_costs_mitigate_losses: "Optimize Costs & Mitigate losses",
  one_password_for_all: "You safely can use only one password for all the software you have to access",
  rely_on_identity_provider: "Rely on an Identity Provider fully built & maintained for you",
  password_cannot_be_stolen: "Your password can't be stolen",
  digital_in_dna: "Digital in DNA",
  digital_in_dna_description: "We're an innovative start-up with Cybersecurity challenges in heart of our DNA. Today, we are offering a panel of services to any clients in order to help them to improve the security of their data, and thus making them more compliant to national/international security regulations like ISO, NIS, NIS2, ISAE, etc.",
  read_our_articles: "Read our articles",
  request_a_demo: "Request a Demo",
  cybersecurity_excellence: "Cybersecurity Excellence",
  cybersecurity_excellence_description: "Our expertise helps businesses protect their most valuable digital assets and maintain compliance with evolving security standards.",
  our_trusted_partners: "Our Trusted Partners",

  // PartnersSlider Component
  they_trust_us: "They trust us",
  trust: "trust",
  join_our_trusted_network: "Join our network of trusted partners",
  become_a_partner: "Become a partner",

  // / EntrepriseDashboard Component
  applications_management: "Applications Management",
  new_application: "New Application",
  add_administrator: "Add Administrator",
  total_applications: "Total Applications",
  total_users: "Total Users",
  average_users_per_app: "Average Users/App",
  applications: "Applications",
  user_distribution_by_application: "User Distribution by Application",
  export_csv: "Export CSV",
  add_new_application: "Add New Application",
  application_created_successfully: "Application created successfully!",
  failed_to_create_application: "Failed to create application. Please try again.",
  administrator_added_successfully: "Administrator added successfully!",
  no_data_to_export: "No data available to export",
  data_exported_successfully: "Data exported successfully",
  application_name: "Application Name",
  user_count: "User Count",


  // DashboardApp Component
  dashboard: "Dashboard",
  error_company_id_not_found: "Error: Company ID not found.",
  error_loading_data: "Error loading data.",
  user_activity_overview: "User Activity Overview",
  additional_insights: "Additional Insights",
  blocked_accounts: "Blocked accounts",
  connection_failures: "Connection failures",
  new_users: "New users",

// Users Component
missing_company_or_app_id: "Company ID or Application ID missing",
user_deleted_successfully: "User deleted successfully",
error_deleting_user: "Error during deletion",
user_locked_successfully: "User locked successfully",
error_locking_user: "Error during locking",
user_unlocked_successfully: "User unlocked successfully",
error_unlocking_user: "Error during unlocking",

  // Contact Component
  contact_us2: "Contact us",
  name: "Name",
  email: "Email",
  message: "Message",
  send: "Send",
  sending: "Sending...",
  message_sent_successfully: "Your message has been sent successfully!",
  failed_to_send_message: "Failed to send message. Please try again later.",
  our_information: "Our Information",
  address: "123 Beige Avenue, City",
  phone: "(123) 456-7890",
  email_contact: "hello@example.com",


  // About Component
  about_otenti: "About Otenti",
  otenti_description: "Otenti is an innovative leader in cybersecurity, specializing in next-generation authentication solutions. Our vision is to make digital security accessible and unbreakable.",
  // our_services: "Our Services", traduction déja presente
  leadership_quote: "Digital transformation opens up new business opportunities while introducing new risks. Our mission is to help organizations navigate this transformation while ensuring their digital security.",
  ceo: "CEO",
  ceo_bio: "xxx xxx leads Otenti's digital transformation and security strategy, with over 15 years of experience in cybersecurity.",
  cto: "CTO",
  cto_bio: "David oversees Otenti's technological development, specializing in advanced authentication and cryptography.",
  cmo: "CMO",
  cmo_bio: "Marie leads Otenti's overall marketing strategy, with particular expertise in B2B cybersecurity marketing.",
  our_leadership_team: "Our Leadership Team",
  leadership_team_description: "Meet the experts behind Otenti's innovative security solutions",
  read_bio: "Read Bio",
  free_demo: "Free Demo",
  free_demo_description: "See our solutions in action with a personalized demo",
  blog: "Blog",
  blog_description: "Get the latest insights on digital security",
  connect_with_otenti: "Connect with Otenti",
  connect_description: "Discover how our solutions can help secure your digital transformation",
  connect_on_linkedin: "Connect on LinkedIn",
  biography: "Biography",
//complement de langueAbout du 15 avril

  // About Component - Général
  close: "Close",
  // learn_more: "Learn More",
  cybersecurity: "Cybersecurity",
  view_bio: "View {name}'s biography",

  // About Component - Notre Mission
  mission_description_new: "To provide you with innovative, reliable, sophisticated, and high-quality solutions tailored to your needs.",
  mission_commitment_title: "Our Commitment",
  mission_commitment_description: "As one of Tsuriel Cyber and IT's products, Otenti is dedicated to delivering top-tier cybersecurity services, addressing both current and future digital challenges.",
  mission_approach_title: "Our Approach",
  mission_approach_description: "Each solution is custom-designed, taking into account your specific requirements and business goals, ensuring optimal protection and a seamless user experience.",

  // About Component - Nos Valeurs
  our_values: "Our Values",
  values_description: "A customer-focused service built on trust and confidentiality, transparency, efficiency, and a sense of responsibility.",
  value_customer_service_title: "Customer-Centric Service",
  value_customer_service_description: "A service centered on the client, attentive to your specific needs.",
  value_confidentiality_title: "Confidentiality",
  value_confidentiality_description: "Rigorous protection of your data and sensitive information.",
  value_transparency_title: "Transparency",
  value_transparency_description: "Clear and honest communication throughout our collaboration.",
  value_trust_title: "Trust",
  value_trust_description: "Relationships built on reliability and professional integrity.",
  value_responsibility_title: "Responsibility",
  value_responsibility_description: "A total commitment to the quality and security of our solutions.",

  // About Component - Nos Services
  services_description: "Otenti, one of Tsuriel Cyber and IT's products, offers services in Cybersecurity, Architecture, Data Security, Digitalization, Audit, Design, and System Improvement.",
  service_cybersecurity_title: "Cybersecurity",
  service_cybersecurity_description: "Advanced protection against digital threats and securing your systems.",
  service_it_architecture_title: "IT Architecture",
  service_it_architecture_description: "Design and implementation of robust and scalable IT infrastructures.",
  service_data_security_title: "Data Security",
  service_data_security_description: "Specialized solutions for the secure protection and management of your data.",
  service_digitalization_title: "Digitalization",
  service_digitalization_description: "Digital transformation tailored to your specific needs and industry sector.",
  service_audit_title: "Audit",
  service_audit_description: "Comprehensive assessment of your systems to identify vulnerabilities and opportunities for improvement.",
  service_design_title: "Design",
  service_design_description: "Creation of intuitive and ergonomic interfaces for an optimal user experience.",
  service_system_improvement_title: "System Improvement",
  service_system_improvement_description: "Optimization of your existing infrastructures for enhanced performance and security.",
  discover_all_services: "Discover All Our Services",

  // About Component - Contact CTA
  secure_digital_title: "Ready to Secure Your Digital Environment?",
  secure_digital_description: "Contact us today for a personalized consultation and discover how Otenti can transform your approach to cybersecurity.",
  request_demo: "Request a Demo",

  // Clés existantes (exemples, à vérifier dans votre Translations.ts)
  // about_otenti: "About Otenti",
  // otenti_description: "...",
  // our_mission: "Our Mission",
  // mission_description: "...",
  // our_services: "Our Services",
  // contact_us: "Contact Us",
  // core_value_security_title: "...",
  // core_value_security_description: "...",
  // core_value_trust_title: "...",
  // core_value_trust_description: "...",
  // core_value_innovation_title: "...",
  // core_value_innovation_description: "...",
  // learn_about_our_values: "Learn About Our Values",
  // leadership_quote: "...",
  // ceo: "CEO",
  // ceo_bio: "...",
  // cto: "CTO",
  // cto_bio: "...",
  // cmo: "CMO",
  // cmo_bio: "...",
  // our_history: "Our History",
  // history_description: "...",
  // history_2020_title: "...",
  // history_2020_description: "...",
  // history_2022_title: "...",
  // history_2022_description: "...",
  // history_2024_title: "...",
  // history_2024_description: "...",
  // our_leadership_team: "Our Leadership Team",
  // leadership_team_description: "...",
  // read_bio: "Read Bio",
  // connect_on_linkedin: "Connect on LinkedIn",
  // biography: "Biography",
  // connect_with_otenti: "Connect with Otenti",
  // connect_description: "...",
  // free_demo: "Free Demo",
  // free_demo_description: "...",
  // contact_us: "Contact Us",
  // contact_us_description: "...",
  // blog: "Blog",
  // blog_description: "...",
  // expertise_title: "...",
  // expertise_description: "...",
  // expertise_item_1: "...",
  // expertise_item_2: "...",
  // expertise_item_3: "...",
  // view_our_services: "View Our Services",
  // contact_our_team: "Contact Our Team",
  // security_excellence_title: "...",
  // security_excellence_description: "...",


  // Sales Component
  our_solutions: "Our Solutions",
  solutions_description: "Choose the perfect plan for your business needs and scale with confidence",
  starter_plan: "Starter",
  starter_price: "€49/month",
  multi_factor_authentication: "Multi-factor authentication",
  up_to_1000_users: "Up to 1000 users",
  email_support: "Email support",
  basic_api_integration: "Basic API integration",
  professional_plan: "Professional",
  professional_price: "€199/month",
  everything_from_starter: "Everything from Starter +",
  up_to_10000_users: "Up to 10,000 users",
  support_24_7: "24/7 support",
  sso_saml_integration: "SSO & SAML integration",
  advanced_analytics: "Advanced analytics",
  enterprise_plan: "Enterprise",
  enterprise_price: "Custom",
  everything_from_professional: "Everything from Professional +",
  unlimited_users: "Unlimited users",
  dedicated_support: "Dedicated support",
  on_premises_deployment: "On-premises deployment",
  full_customization: "Full customization",
  subscribe: "Subscribe",
  payment_for: "Payment for {plan}",
  full_name: "Full Name",
  card_number: "Card Number",
  card_number_placeholder: "1234 5678 9012 3456",
  expiry_date: "Expiry Date",
  expiry_date_placeholder: "MM/YY",
  cvv: "CVV",
  cvv_placeholder: "123",
  pay: "Pay {price}",
  processing: "Processing...",
  payment_secure: "Your payment information is secure and encrypted",
  payment_success: "Thank you! Your subscription to {plan} has been processed successfully.",
  payment_failed: "Failed to process payment. Please try again later.",
  our_applications: "Our Applications",
  crm_pro: "CRM Pro",
  crm_pro_description: "A comprehensive solution for customer relationship management.",
  erp_suite: "ERP Suite",
  erp_suite_description: "A powerful software for resource and production management.",
  ecommerce_boost: "E-Commerce Boost",
  ecommerce_boost_description: "Optimize cascadingly optimize images",
  // ecommerce_boost: "Optimize your online store with advanced tools.", clé à changer
  // learn_more: "Learn More", traduction existantte 
  custom_solution_title: "Need a custom solution?",
  custom_solution_description: "Our team of experts is ready to help you build the perfect solution tailored to your specific business needs",
  contact_our_team: "Contact Our Team",


  // Support Component
  support_center: "Otenti Support Center",
  support_center_description: "Get help with our authentication solutions and services",
  view_full_faq: "View Full FAQ",
  start_live_chat: "Start Live Chat",
  support_status: "Support Status: Online",
  avg_response_time: "Avg. response time: 2 hours",
  frequently_asked_questions: "Frequently Asked Questions",
  faq_mfa_question: "How to set up two-factor authentication?",
  faq_mfa_answer: "To set up two-factor authentication, navigate to Account Settings > Security > Two-Factor Authentication and follow the on-screen instructions to configure your preferred method.",
  faq_api_question: "Where to find the API documentation?",
  faq_api_answer: "Our comprehensive API documentation is available in the Developer Portal. Log in to your account, navigate to the Developer section, and select API Documentation.",
  faq_password_question: "How do I reset my password?",
  faq_password_answer: "To reset your password, click on the 'Forgot Password' link on the login page. You will receive an email with instructions to create a new password.",
  support_tickets: "Support Tickets",
  create_ticket: "Create a Ticket",
  my_tickets: "My Tickets",
  create_new_ticket: "Create New Support Ticket",
  tips_for_resolution: "Tips for Faster Resolution",
  tip_describe_problem: "Clearly describe your problem with all relevant details.",
  tip_include_screenshots: "Include screenshots or error messages if applicable.",
  tip_list_steps: "List the steps you've already taken to resolve the issue.",
  subject: "Subject",
  subject_placeholder: "Brief description of your issue",
  detailed_description: "Detailed Description",
  description_placeholder: "Please provide as much detail as possible...",
  priority: "Priority",
  priority_low: "Low",
  priority_medium: "Medium",
  priority_high: "High",
  category: "Category",
  category_technical: "Technical Issue",
  category_billing: "Billing Question",
  category_feature: "Feature Request",
  category_other: "Other",
  submit_ticket: "Submit Support Ticket",
  ticket_submitted_success: "Ticket submitted successfully!",
  all_tickets: "All Tickets",
  open_tickets: "Open",
  resolved_tickets: "Resolved",
  no_tickets_found: "No tickets found",
  no_tickets_message: "No tickets match your current filter criteria.",
  status_open: "Open",
  status_resolved: "Resolved",
  ticket_number: "Ticket #{id}",
  created_on: "Created on {date}",
  update_ticket: "Update",
  close_ticket: "Close",
  support_response: "Support Response",
  pdf_document: "PDF Document • 2.4 MB",
  view: "View",
  download: "Download",
  response_helpful: "Was this response helpful?",
  click_to_rate: "Click to rate",
  contact_us_directly: "Contact Us Directly",
  phone_support: "Phone Support",
  // email_support: "Email Support",  traduction existante 
  start_live_chat_now: "Start Live Chat Now",
  support_hours: "Support Hours",
  monday_friday: "Monday - Friday",
  monday_friday_hours: "9:00 AM - 6:00 PM",
  saturday: "Saturday",
  saturday_hours: "10:00 AM - 4:00 PM",
  sunday: "Sunday",
  sunday_hours: "Closed",
  emergency_support: "Emergency Support",
  emergency_support_description: "For critical issues outside business hours, premium customers can access our 24/7 emergency support.",
  learn_premium_support: "Learn about premium support",
  ticket_mfa_subject: "MFA Configuration Issue",
  ticket_mfa_description: "I cannot set up two-factor authentication...",
  ticket_mfa_response: "Here are the steps to resolve your MFA configuration issue...",
  ticket_api_subject: "API Documentation",
  ticket_api_description: "Request for detailed documentation for API integration",
  ticket_api_response_content: "Documentation_API_Otenti.pdf",

  

  // Articles Component    Modele a copier pour simplifier les autres article. 
  articles_and_news: "Articles and News",
  read_article: "Read article",
  back_to_articles: "Back to articles",
  close_article: "Close article",
  close_article_aria: "Close article",
  article_mfa_title: "The Importance of Multi-Factor Authentication in 2025",
  article_mfa_description: "Discover how multi-factor authentication has become essential for the security of modern businesses.",
  article_mfa_date: "January 21, 2025",
  article_mfa_content: `
    # The Importance of Multi-Factor Authentication in 2025

    In an increasingly connected world, data security has become a major concern for businesses. Multi-factor authentication (MFA) has emerged as a crucial solution to protect sensitive access.

    ## Why is MFA Crucial?

    Cyberattacks are becoming more sophisticated. A simple password is no longer enough to ensure the security of your data. In 2024, over 80% of data breaches involved compromised credentials.

    Multi-factor authentication adds extra layers of security by combining:
    - Something you know (password)
    - Something you have (smartphone, token)
    - Something you are (fingerprint, facial recognition)

    ## Concrete Benefits for Your Business

    - 99.9% reduction in account compromise risks according to recent studies
    - Compliance with regulations like GDPR, PCI DSS, and others
    - Enhanced trust from customers and partners
    - Protection against phishing and brute-force attacks

    ## How to Effectively Implement MFA

    Implementing an MFA solution should be thoughtful so as not to harm the user experience. Our experts recommend a gradual approach with a flexible solution that adapts to different usage contexts.

    Contact us to find out how our solution can secure your business while maintaining a smooth user experience.
  `,
  article_tsuriel_title: "Securing Your Data with Tsuriel Authentication",
  article_tsuriel_description: "An in-depth analysis of the advanced security features of our authentication solution.",
  article_tsuriel_date: "January 18, 2025",
  article_tsuriel_content: `
    # Securing Your Data with Tsuriel Authentication

    Our Tsuriel Authentication solution represents the state of the art in authentication security. Here's a detailed analysis of the features that set it apart.

    ## Advanced Security Architecture

    Tsuriel Authentication uses a zero-trust architecture with end-to-end encryption. All data is encrypted in transit and at rest with the latest industry-recognized algorithms.

    ## Key Features

    1. **Contextual Authentication**
       Our system evaluates in real-time the risk level of each login attempt by analyzing multiple factors: location, device, user behavior, etc.

    2. **Next-Generation Biometrics**
       Beyond fingerprints, our solution integrates 3D facial recognition, voice recognition, and even behavioral analysis.

    3. **Centralized Policy Management**
       An intuitive admin console allows you to define granular access policies tailored to different user groups.

    ## Case Studies

    Our clients have reported:
    - 95% reduction in security incidents related to authentication
    - 60% decrease in support calls for password resets
    - 25% increase in user satisfaction due to smoother login processes

    Discover how Tsuriel Authentication can transform your security strategy by scheduling an appointment with one of our experts.
  `,
  article_ux_security_title: "How to Improve User Experience While Strengthening Security",
  article_ux_security_description: "Best practices for maintaining a balance between security and usability.",
  article_ux_security_date: "January 15, 2025",
  article_ux_security_content: `
    # How to Improve User Experience While Strengthening Security

    Balancing robust security with a smooth user experience is often seen as an insurmountable challenge. However, modern approaches demonstrate that it is possible to achieve both goals simultaneously.

    ## The False Dilemma of Security vs. Experience

    Historically, more security meant more friction for the user. Today, smart technologies allow for dynamic adjustments to security levels based on context, reducing friction in low-risk scenarios.

    ## Effective Strategies

    ### 1. Progressive Authentication
    Start with a simple method, then add factors only when the context demands (sensitive operation, unusual behavior).

    ### 2. Transparent Biometrics
    Modern biometric technologies can work in the background without active user intervention.

    ### 3. Secure Single Sign-On (SSO)
    Allow users to access multiple applications with a single strong authentication rather than remembering multiple credentials.

    ## Concrete Results

    Companies that have adopted these approaches have observed:
    - 35% increase in user adoption of solutions
    - 40% decrease in security bypasses by employees
    - Better perception of security policies within the organization

    Our team can assist you in implementing these strategies to transform security from a perceived obstacle into a competitive advantage.
  `,
  // SearchPage Component
  advanced_search: "Advanced Search",
  search_placeholder: "Search...",
  search_button: "Search",
  loading: "Loading...",
  no_results_found: "No results found for \"{query}\"",
  category_all: "All",
  category_Application: "Application",
  category_users: "Users",
  category_Articles: "Articles",
  category_documents: "Documents",
  search_result_tech_company_title: "Tech Company",
  search_result_tech_company_description: "Enterprise technology solutions",
  search_result_ibro_title: "Ibro",
  search_result_ibro_description: "Software Engineer at Tech Company",
  search_result_project_proposal_title: "Project Proposal",
  search_result_project_proposal_description: "Technical documentation for new project",

  
  // RolesPage Component
  roles_management: "Roles management",
  add_role: "Add a Role",
  role_name: "Role Name",
  actions: "Actions",
  edit_role: "Edit role",
  delete_role: "Delete role",
  open_menu: "Open menu",
  add_new_role: "Add a new role",
  enter_role_name: "Enter the role name",
  edit_role_name: "Edit the role name",
  no_roles_available: "No roles available",
  role_added_success: "Role successfully added",
  role_modified_success: "Role successfully modified",
  role_deleted_success: "Role successfully deleted",
  error_loading_roles: "Error loading roles",
  error_adding_role: "Error adding role",
  error_modifying_role: "Error modifying role",
  error_deleting_role: "Error deleting role",
  unexpected_response_format: "Unexpected response format",
  add: "Add",
  save: "Save",
  // cancel: "Cancel", traduction existante

  // Sidebar Component
  menu: "Menu",
  nav_home: "Home",
  nav_applications: "Applications",
  nav_administrator: "Administrator",
  nav_settings: "Settings",
  expand_sidebar: "Expand sidebar",
  collapse_sidebar: "Collapse sidebar",


  // SidebarApp Component
  app_secure_by_otenti: "App secure by Otenti",
  nav_dashboard: "Dashboard",
  nav_users: "Users",
  nav_roles: "Roles",
  nav_support: "Support",
  // nav_settings: "Settings", // Déjà défini dans Sidebar.tsx
  // expand_sidebar: "Expand sidebar", // Déjà défini dans Sidebar.tsx
  // collapse_sidebar: "Collapse sidebar", // Déjà défini dans Sidebar.tsx


  // UserList Component
  users_list: "Users List",
  search_users: "Search Users...",
  add_users: "Add Users",
  loading_users: "Loading Users...",
  error_loading_users: "Error loading users",
  // email: "Email",
  // full_name: "Full Name",
  status: "Status",
  // actions: "Actions",
  details: "Details",
  // add_role: "Add role",
  edit: "Edit",
  lock: "Lock",
  unlock: "Unlock",
  delete: "Delete",
  view_details: "View details",
  status_active: "Active",
  status_locked: "Locked",
  add_role_to_user: "Add role to {user}",
  select_role: "Select role",
  select_role_placeholder: "Select a role",
  please_select_role: "Please select a role",
  // role_added_success: "Role added successfully",
  // error_loading_roles: "Failed to load roles",
  error_loading_roles_log: "Error loading roles",
  // error_adding_role: "Failed to add role",
  error_adding_role_log: "Error adding role",
  // add: "Add", // Déjà défini dans RolesPage.tsx
  // cancel: "Cancel", // Déjà défini dans RolesPage.tsx
  // roles: "Roles", // Déjà défini dans RolesPage.tsx

  // UserDetails Component
  user_details: "User Details",
  last_activity: "Last Activity",
  last_login: "Last Login",
  not_available: "N/A",
  // close: "Close",
  // delete_role: "Delete this role", Déja present cette clé
  error_deleting_role_log: "Error deleting the role",
  // email: "Email", // Déjà défini dans UserList.tsx
  // full_name: "Full Name", // Déjà défini dans UserList.tsx
  // status: "Status", // Déjà défini dans UserList.tsx
  // roles: "Roles", // Déjà défini dans UserList.tsx
  // status_active: "Active", // Déjà défini dans UserList.tsx
  // status_locked: "Locked", // Déjà défini dans UserList.tsx
  // role_deleted_success: "Role deleted successfully", // Déjà défini dans RolesPage.tsx
  // error_deleting_role: "Failed to delete the role", // Déjà défini dans RolesPage.tsx
  // Anglais (EN)


  // UserFormModal Component
  new_user: "New User",
  edit_user: "Edit User",
  email_placeholder: "email@example.com",
  full_name_placeholder: "First Last",
  update: "Update",
  user_added_success: "User added successfully",
  user_updated_success: "User updated successfully",
  error_user_action: "Error during {action} the user",
  adding: "adding",
  updating: "updating",
  // email: "Email", // Déjà défini dans UserList.tsx
  // full_name: "Full Name", // Déjà défini dans UserList.tsx
  // roles: "Roles", // Déjà défini dans UserList.tsx
  // add: "Add", // Déjà défini dans RolesPage.tsx
  // cancel: "Cancel", // Déjà défini dans RolesPage.tsx
  // close: "Close", // Déjà défini dans UserDetails.tsx


  
    // ApplicationFileUpload Component
    drag_drop_csv: "Drag and drop a CSV file here, or click to select",
    drop_csv: "Drop the CSV file here...",
    scanning_file: "Scanning file for security...",
    download_template: "Download Template",
    template_filename: "application_roles_template.csv",
    file_constraints: "Max file size: 1MB • Only plain CSV files accepted",
    error_no_file_selected: "No file selected",
    error_only_csv: "Only CSV files are accepted",
    error_invalid_file_type: "Invalid file type",
    error_security_risk: "File rejected: potential security risk detected",
    error_invalid_csv_structure: "Invalid CSV structure. Must contain 'Role' column",
    error_no_valid_roles: "No valid roles found in CSV file",
    error_parsing_csv: "Error parsing CSV file",
    error_invalid_csv: "Invalid CSV file",
  // UsersDistributionChart Component
  users_distribution: "Distribution des utilisateurs par application",
  loading_user_data: "Chargement des données des utilisateurs...",
  no_user_data: "Aucune donnée utilisateur disponible",
  showing_applications: "Affichage de {appCount} applications avec {userCount} utilisateurs",
  application: "Application",
  // users: "Utilisateurs",présent déja
  percentage: "Pourcentage",
  users_count: "{count} utilisateurs",
  app_fallback: "Appli {id}",
  csv_downloaded: "CSV téléchargé !",
  pdf_downloaded: "PDF téléchargé !",
  users_distribution_filename_csv: "distribution_utilisateurs.csv",
  users_distribution_filename_pdf: "distribution_utilisateurs.pdf",
  chart_info: "Informations sur le graphique",
  // export_csv: "Exporter en CSV",déja present
  export_pdf: "Exporter en PDF",
  error_export_csv_log: "Erreur d'exportation CSV",
  error_export_pdf_log: "Erreur d'exportation PDF",

  // SettingApp Component
  settings: "Settings",
  // loading: "Loading...",
  error_loading: "Error loading data",
  // description: "Description",
  no_description: "No description",
  client_id: "Client ID",
  // status: "Status",
  // status_active: "Active",
  status_inactive: "Inactive", // Ajouté pour d'autres statuts possibles
  copy: "Copy",
  copy_application_name: "Copy application name",
  copy_client_id: "Copy client ID",
  copy_redirect_uri: "Copy redirect URI",
  // edit: "Edit",
  edit_status: "Edit status",
  status_edit_alert: "Status modification feature not yet implemented",
  delete_app: "Delete application",
  update_settings: "Update Settings",
  confirm_deletion: "Confirm Deletion",
  delete_confirmation: "Do you really want to delete '{appName}'? This action cannot be undone.",
  error_delete_app_log: "Error deleting application",
  error_update_app_log: "Error updating application",
  edit_application: "Edit Application",
  post_logout_redirect_uris: "Post-Logout Redirect URIs",
copy_post_logout_redirect_uris:" Copy post-logout redirect URIs",
no_post_logout_redirect_uris: "No post-logout redirect URIs specified",
active: "Active",
blocked: "Blocked",
  // Réutilisées :
  // application_name: "Application Name", // Depuis ApplicationForm.tsx
  // redirect_uri: "Redirect URI", // Depuis ApplicationForm.tsx
  // cancel: "Cancel", // Depuis UserFormModal.tsx, ApplicationForm.tsx
  // delete: "Delete", // Depuis UserList.tsx, UserDetails.tsx
  // save: "Save", // Depuis UserFormModal.tsx (synonyme de "Update")
  // Dans Translation.ts, ajouter ces clés dans chaque section de langue (EN, FR, ES)

  // AddRoleModal Component
  // add_new_role: "Add New Role",
  // role_name: "Role Name",
  // enter_role_name: "Enter the role name",
  // add: "Add",
  // add_role: "Add role",
  error_add_role_log: "Error adding role",
  // Réutilisée :



  // cancel: "Cancel", // Depuis UserFormModal.tsx, ApplicationForm.tsx, SettingApp.tsx


    become_client_title: "Become a Client",
    become_client_description: "Fill out the following information to submit your request",
    watch_demonstration: "Watch Demonstration",
    demo_modal_title: "Need help with registration?",
    demo_modal_description: "Would you like to watch a demonstration video explaining how to complete your registration request?",
    demo_modal_skip: "No, thank you",
    demo_modal_watch: "Watch Demo",
    demo_video_title: "How to Become a Client",
    demo_video_description: "This video guides you through the client registration process.",
    start_registration: "Start Registration",
    step_information: "Information",
    step_plan: "Plan",
    step_confirmation: "Confirmation",
    company_information: "Company Information",
    choose_plan: "Choose Your Plan",
    request_sent_success: "Request Sent Successfully!",
    request_review_message: "Our team will review your request and contact you shortly.",
    back_to_homepage: "Back to Homepage",
    error_registering_company: "Error registering company",



  // LandingPage - Général
  // percentage: "%",
  no_data_available: "No data available for the selected period",
  failed_to_load_data: "Failed to load application data. Please try again later.",
  // view_details: "View details for {title}",

  // Périodes
  period: "Period",
  select_period: "Select a period",
  select_option: "Select {label}",
  months: "3 months",
   monthss: "6 months",
  // 6_months: "6 months",
  year: "year",
  all_time: "All time",

  // Menu
  // menu: "Menu",
  dashboard_company: "Dashboard Company",
  generate_new_key: "Generate New Key",
  request_registration: "Request Registration",
  edit_notification_list: "Edit Notification List",
  // settings: "Settings",

  // Export
  global_export: "Global Export",
  global_export_description: "Export complete company statistics including all applications and user data.",
  export_full_report: "Export Full Report (CSV)",
  preparing_data: "Preparing data...",
  no_data_for_export: "No data available for export in the selected period.",
  company_stats_report: "company-stats-report",
  // application: "Application",
  authentication_rate: "Authentication Rate",
  failed_logins: "Failed Logins",
  locked_accounts: "Locked Accounts",
  inactive_users: "Inactive Users",

  // CompanyStatsChart
  statistics_over: "Statistics over {period}",
  authentication_rate_by_app: "Authentication Rate by Application",
  login_failures_by_app: "Login Failures by Application",
  locked_accounts_by_app: "Locked Accounts by Application",
  user_inactivity_by_app: "User Inactivity by Application",
  low_authentication_warning: "Some applications have low authentication rates",
  high_failure_warning: "Some applications have high failure rates",
  high_lock_warning: "Some applications have high lock rates",
  high_inactivity_warning: "Some applications have high inactivity rates",

  // StatSummaryCard
  from_previous_period: "from previous period",

  // AnalyticsHub
  analytics_hub: "Analytics Insights Hub",
  analytics_hub_description: "Interactive dashboard to monitor application security performance",
  overview: "Overview",
  security_status: "Security Status",
  user_activity: "User Activity",

  // AnalyticsHub - Overview
  apps_performance_summary: "Applications Performance Summary",
  quick_insights: "Quick Insights",
  low_authentication_insight: "Authentication rates are below target. Consider user training or simplified authentication flows.",
  high_failure_insight: "High failure rates detected. Check for potential security issues or user interface problems.",
  high_lockout_insight: "Elevated account lockouts indicate possible brute force attempts or user password issues.",
  high_inactivity_insight: "High user inactivity rates. Consider engagement campaigns or account cleanup.",
  healthy_metrics_insight: "All application metrics are within healthy ranges. Continue monitoring for optimal security.",
  recommended_actions: "Recommended Actions",
  view_all_recommendations: "View all recommendations",
  manage_users: "Manage Users",
  manage_users_description: "Configure access controls and user permissions",
  security_settings: "Security Settings",
  security_settings_description: "Review and update security policies",
  notifications: "Notifications",
  notifications_description: "Configure security and activity alerts",

  // AnalyticsHub - Security Status
  security_status_overview: "Security Status Overview",
  auth_status_distribution: "Authentication Status Distribution",
  security_risk_assessment: "Security Risk Assessment",
  authentication_health: "Authentication Health",
  login_failures: "Login Failures",
  account_lockouts: "Account Lockouts",
  // user_activity: "User Activity",
  review_security_settings: "Review Security Settings",
  authenticated: "Authenticated",
  locked: "Locked",
  inactive: "Inactive",

  // AnalyticsHub - User Activity
  user_activity_metrics: "User Activity Metrics",
  active_vs_inactive_users: "Active vs. Inactive Users by Application",
  active_users: "Active Users %",
  user_engagement_summary: "User Engagement Summary",
  user_engagement_description: "Applications show an average of {active}% active users vs {inactive}% inactive users.",
  security_event_summary: "Security Event Summary",
  security_event_description: "Applications show an average of {failed}% failed logins and {locked}% locked accounts.",
  configure_alerts: "Configure Alerts",





  // FailedLoginsChart
  // percentage: "%",
  // loading: "Loading...",
  // error_loading: "Error loading data",
  download_error: "An error occurred while downloading",
  login_failure_statistics: "Login Failure Statistics",
  // select_period: "Select a period",
  // select_option: "Select {label}",
  Hours24: "24 hours",
  days7: "7 days",
  days30: "30 days",
  days90: "90 days",
  // download: "Download",
  png: "PNG",
  download_png: "Download as PNG",
  jpeg: "JPEG",
  download_jpeg: "Download as JPEG",
  pdf: "PDF",
  download_pdf: "Download as PDF",
  failed_logins_period: "Failed ({period})",
  successful_logins: "Successful logins",
  failed_login_summary: "{percentage}% of users ({count}/{totalUsers}) experienced login failures in the last {period}.",
  // high_failure_warning: "Warning: Unusually high failure rate",
  login_failure_kpi: "Login-Failure-KPI",



  // InactiveUsersChart
  // percentage: "%",
  // loading: "Loading...",
  // error_loading: "Error loading data",
  // download_error: "An error occurred while downloading",
  user_inactivity_status: "User Inactivity Status",
  // select_period: "Select a period",
  // select_option: "Select {label}",
  // days30: "30 days",
  days60: "60 days",
  // days90: "90 days",
  // days180: "180 days",
  // download: "Download",
  // png: "PNG",
  // download_png: "Download as PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Download as JPEG",
  // pdf: "PDF",
  // download_pdf: "Download as PDF",
  inactive_users_period: "Inactive ({period}+)",
  // active_users: "Active users",
  inactive_user_summary: "{percentage}% of users ({count}/{totalUsers}) have been inactive for more than {period}.",
  recently_inactive_summary: "{count} users became inactive in this period.",
  // high_inactivity_warning: "Warning: High inactivity rate may indicate unused accounts",
  inactive_users_kpi: "Inactive-Users-KPI",



  // LockedUsersChart
  // percentage: "%",
  // loading: "Loading...",
  // error_loading: "Error loading data",
  // download_error: "An error occurred while downloading",
  account_lock_status: "Account Lock Status",
  // select_period: "Select a period",
  // select_option: "Select {label}",
  hours24: "24 hours",
  days24: "7 days",
  // days30: "30 days",
  // all_time: "All time",
  // download: "Download",
  // png: "PNG",
  // download_png: "Download as PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Download as JPEG",
  // pdf: "PDF",
  // download_pdf: "Download as PDF",
  locked_users: "Locked users",
  // active_users: "Active users",
  locked_user_summary: "{percentage}% of accounts ({count}/{totalUsers}) are currently locked.",
  recent_locks_summary: "{count} accounts were locked in the last {period}.",
  // high_lock_warning: "Warning: High lock rate may indicate security issues",
  locked_users_kpi: "Locked-Users-KPI",


 

  // AuthPercentageChart
  // percentage: "%",
  // loading: "Loading...",
  // error_loading: "Error loading data",
  // download_error: "An error occurred while downloading",
  user_authentication_rate: "User Authentication Rate",
  // select_period: "Select a period",
  // select_option: "Select {label}",
  // days7: "7 days",
  // days30: "30 days",
  // days90: "90 days",
  days180: "180 days",
  // download: "Download",
  // png: "PNG",
  // download_png: "Download as PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Download as JPEG",
  // pdf: "PDF",
  // download_pdf: "Download as PDF",
  authenticated_users_period: "Authenticated ({period})",
  not_authenticated_users: "Not authenticated",
  auth_summary: "{percentage}% of users authenticated in the last {period}.",
  low_auth_warning: "Warning: Low authentication rate may indicate inactive users",
  authentication_kpi: "Authentication-KPI",

  // FAQ
  faq: "FAQ",
  // frequently_asked_questions: "Frequently Asked Questions",
  faq_subtitle: "Find answers to the most common questions about our authentication services",
  expand_faq: "Expand {question}",
  collapse_faq: "Collapse {question}",
  // faq_mfa_question: "What is multi-factor authentication (MFA)?",
  // faq_mfa_answer: "Multi-factor authentication is a security method that requires users to provide two or more different proofs of identity to access an account. Otenti offers several MFA options, including SMS, authentication applications, and physical security keys.",
  faq_data_protection_question: "How does Otenti protect my users' data?",
  faq_data_protection_answer: "Otenti uses end-to-end encryption, stores data in secure data centers, and follows industry best practices for security. We comply with GDPR, CCPA, and other important data protection regulations.",
  faq_customization_question: "Can I customize the authentication interface?",
  faq_customization_answer: "Yes, Otenti offers complete customization options. You can adapt the interface to your brand colors, modify authentication flows, and customize messages for your users.",
  faq_uptime_question: "What are the service uptime rates?",
  faq_uptime_answer: "Otenti guarantees 99.99% service uptime. We maintain a redundant infrastructure and monitor our systems 24/7 to ensure reliable authentication at all times.",
  faq_integration_question: "How do I integrate Otenti with my existing application?",
  faq_integration_answer: "Otenti provides easy-to-integrate SDKs and APIs for major platforms and programming languages. Our detailed documentation and technical support team will guide you through the integration process.",
  faq_support_question: "What technical support is available?",
  faq_support_answer: "We offer 24/7 technical support for enterprise customers, with guaranteed response times based on your service level. Our team of experts is available by email, chat, and phone.",
  faq_user_management_question: "How do I manage users and their permissions?",
  faq_user_management_answer: "Otenti offers a comprehensive administration dashboard to manage users, roles, and permissions. You can easily add/remove users, set security policies, and track activities.",
  faq_pricing_question: "What are the pricing options?",
  faq_pricing_answer: "We offer several packages tailored to the needs of businesses of all sizes, from startups to large accounts. Contact our sales team for a personalized quote based on your specific needs.",


    // NotFound
    not_found_title: "404 - Page Not Found",
    not_found_message: "The page you are looking for does not exist.",
    back_to_home: "Back to Home",

  
        video_tutorials: "Video Tutorials",
        integration_tutorials: "Integration Tutorials",
        usage_tutorials: "Usage Tutorials",
        watch_tutorial: "Watch Tutorial",
        video_not_supported: "Your browser does not support video playback.",
        tutorial_react_integration_title: "Integrate Otenti with Your React Application",
        tutorial_react_integration_desc: "Complete guide to connect your React application to Otenti",
        tutorial_nodejs_auth_title: "Authentication in Node.js Applications",
        tutorial_nodejs_auth_desc: "Procedure for setting up authentication for Node.js applications",
        tutorial_angular_mfa_title: "Setting Up MFA with Angular",
        tutorial_angular_mfa_desc: "Configuring multi-factor authentication for Angular projects",
        tutorial_user_management_title: "Managing Users in Otenti",
        tutorial_user_management_desc: "Learn how to manage users and permissions in the Otenti dashboard",
        tutorial_dashboard_usage_title: "Using the Otenti Dashboard",
        tutorial_dashboard_usage_desc: "Guide to navigating and utilizing the Otenti administration dashboard",
 
  
  
    // General sections
    // video_tutorials: 'Video Tutorials',
    // integration_tutorials: 'Integration Tutorials',
    // usage_tutorials: 'Usage Tutorials',
    // watch_tutorial: 'Watch Tutorial',
    // video_not_supported: 'Your browser does not support video playback.',
    
    // // Integration tutorial titles
    // tutorial_react_integration_title: 'React Integration Tutorial',
    // tutorial_nodejs_auth_title: 'Node.js Authentication Tutorial',
    // tutorial_angular_mfa_title: 'Angular MFA Authentication Tutorial',
    tutorial_vue_integration_title: 'Vue.js Integration Tutorial',
    tutorial_flutter_integration_title: 'Flutter Integration Tutorial',
    
    // Integration tutorial descriptions
    // tutorial_react_integration_desc: 'Learn how to integrate Otenti authentication with your React application in a few simple steps.',
    // tutorial_nodejs_auth_desc: 'Set up secure authentication in your Node.js backend with our Otenti API.',
    // tutorial_angular_mfa_desc: 'Implement multi-factor authentication in your Angular application for enhanced security.',
    tutorial_vue_integration_desc: 'Comprehensive guide to integrating Otenti authentication in your Vue.js project.',
    tutorial_flutter_integration_desc: 'Configure Otenti authentication in your Flutter mobile application in minutes.',
    
    // Integration video URLs
    tutorial_react_integration_video: '/OtentiTutoConnectApp.mp4',
    tutorial_nodejs_auth_video: '/OtentiTutoReact.mp4',
    tutorial_angular_mfa_video: '/videos/otenti-angular-mfa_en.mp4',
    tutorial_vue_integration_video: '/videos/otenti-vue-integration_en.mp4',
    tutorial_flutter_integration_video: '/videos/otenti-flutter-integration_en.mp4',
    
    // Integration thumbnail URLs
    tutorial_react_integration_thumbnail: '/thumbnails/react-integration_en.jpg',
    tutorial_nodejs_auth_thumbnail: '/thumbnails/nodejs-auth_en.jpg',
    tutorial_angular_mfa_thumbnail: '/thumbnails/angular-mfa_en.jpg',
    tutorial_vue_integration_thumbnail: '/thumbnails/vue-integration_en.jpg',
    tutorial_flutter_integration_thumbnail: '/thumbnails/flutter-integration_en.jpg',
    
    // Usage tutorial titles
    tutorial_create_application: 'Create a New Application',
    tutorial_add_user: 'Add and Manage Users',
    tutorial_add_role: 'Role and Permission Configuration',
    tutorial_user_management: 'User Account Management',
    tutorial_chart_usage: 'Dashboard and Statistics Usage',
    
    // Usage tutorial descriptions
    tutorial_create_application_desc: 'Discover how to create and configure a new application in the Otenti portal.',
    tutorial_add_user_desc: 'Learn how to add users to your application and manage their information.',
    tutorial_add_role_desc: 'Guide to configuring custom roles and assigning specific permissions.',
    // tutorial_user_management_desc: 'Efficiently manage user accounts, active sessions, and access to your application.',
    tutorial_chart_usage_desc: 'Master the use of charts and dashboards to track your application activity.',
    
    // Usage video URLs
    tutorial_create_application_video: '/videos/otenti-create-application_en.mp4',
    tutorial_add_user_video: '/videos/otenti-add-user_en.mp4',
    tutorial_add_role_video: '/videos/otenti-add-role_en.mp4',
    tutorial_user_management_video: '/videos/otenti-user-management_en.mp4',
    tutorial_chart_usage_video: '/videos/otenti-chart-usage_en.mp4',
    
    // Usage thumbnail URLs
    tutorial_create_application_thumbnail: '/Otentitutominiature.PNG',
    tutorial_add_user_thumbnail: '/Otentitutominiature.PNG',
    tutorial_add_role_thumbnail: '/thumbnails/add-role_en.jpg',
    tutorial_user_management_thumbnail: '/thumbnails/user-management_en.jpg',
    tutorial_chart_usage_thumbnail: '/thumbnails/chart-usage_en.jpg',

// Notification list
        notification_email_list: "Notification Email List",
        // close: "Close",
        enter_email_address: "Enter email address",
        loading_emails: "Loading emails...",
        no_emails_added: "No emails added yet",
        email_required: "Email address is required",
        invalid_email_format: "Invalid email format",
        email_already_exists: "This email already exists",
        email_added_successfully: "Email added successfully!",
        failed_to_add_email: "Failed to add email. Please try again.",
        email_updated_successfully: "Email updated successfully!",
        failed_to_update_email: "Failed to update email. Please try again.",
        email_removed_successfully: "Email removed successfully!",
        failed_to_remove_email: "Failed to remove email. Please try again.",
        failed_to_load_emails: "Failed to load emails. Please try again.",
        edit_email: "Edit email",
        save_email: "Save email",
        remove_email: "Remove email",

      // Adminlist
            administrators: "Administrators",
            manage_administrators: "Manage administrators",
            view_administrators: "View administrators",
            super_admin: "Super Admin",
            full_privileges: "Full Privileges",
            delete_administrator: "Delete administrator",
            action_reserved_for_super_admins: "Action reserved for super administrators",
            loading_administrators: "Loading administrators...",
            no_administrators_found: "No administrators found for this company",
            select_company_to_view_admins: "Please select a company to view its administrators",
            admin_count: "Number of admins: {count}/3",
            error_loading_administrators: "Error loading administrators",
            administrator_deleted_successfully: "Administrator deleted successfully",
            error_deleting_administrator: "Error deleting administrator",
            company_id_missing: "Company ID is missing",
            only_super_admin_can_delete: "Only a super administrator can delete administrators",
            cannot_delete_own_account: "You cannot delete your own account",
            confirm_delete_admin: "Are you sure you want to delete the administrator {name}?",
        //  Page des administrateurs
                loading_user: "Loading user...",
                error_loading_user: "Error loading user. Please try again.",
                admin_management: "Admin Management",
                create_admin: "Create an Admin",
                only_super_admins_can_create: "Only super administrators can create administrators",
                admin_created_successfully: "Administrator created successfully! 🎉",
// Modal d A JOUT D4UN ADMINISTRATEUR
                      // add_administrator: "Add Administrator",
                    close_modal: "Close modal",
                    // full_name: "Full Name",
                    // email: "Email",
                    enter_full_name: "Enter full name",
                    // enter_email_address: "Enter email address",
                    full_name_required: "Full name is required",
                    // email_required: "Email is required",
                    // invalid_email_format: "Invalid email format",
                    failed_to_create_admin: "Failed to create admin",
                    // cancel: "Cancel",
                    creating: "Creating...",
                    add_administrator_button: "Add Administrator",

              // DETAILS DES TICKETS 
                        ticket_details: "Ticket Details",
                        refresh_data: "Refresh Data",
                        data_refreshed: "Data Refreshed",
                        error_loading_ticket: "Error Loading Ticket",
                        error_loading_ticket_message: "Unable to load ticket details. Please try again later.",
                        back_to_tickets: "Back to Tickets",
                        loading_ticket: "Loading Ticket",
                        please_wait: "Please wait...",
                        ticket_content: "Ticket Content",
                        discussion: "Discussion",
                        no_comments_yet: "No comments yet",
                        write_your_message: "Write your message",
                        support_team: "Support Team",
                       last_updated: "Last Updated",
                        // priority_high: "High",
                        // priority_medium: "Medium",
                        // priority_low: "Low",
                        // category_technical: "Technical",
                        // category_billing: "Billing",
                        // category_feature: "Feature",
                        // category_other: "Other",
                        created_by: "Created By",
                        company_id: "Company ID",
                        // close: "Close",
                        ticket_closed_success: "Ticket Closed Successfully",
                        ticket_closed_success_message: "The ticket has been closed successfully.",
                        ticket_reopened: "Ticket Reopened",
                        ticket_reopened_message: "The ticket has been reopened successfully.",
                        ticket_status_update_failed: "Ticket Status Update Failed",
                        ticket_status_update_failed_message: "Unable to update ticket status. Please try again.",
                        comment_submission_failed: "Comment Submission Failed",
                        comment_submission_failed_message: "Unable to submit comment. Please try again.",
                        // close_ticket: "Close Ticket",
                        reopen_ticket: "Reopen Ticket",
                        updating_status: "Updating Status",
                        ticket_closed_message: "This ticket is closed. You can reopen it if needed.",
                     
                        
                
                            companyName: "{companyName}",
                            applicationName: "{applicationName} Dashboard",
                            // loading: "Loading...",
                            user: "User",
                            confirmLogout: "Confirm logging out",
                            logoutQuestion: "Do you really want to log out?",
                            // cancel: "Cancel",
                            // logout: "Log Out",
                            // dashboard: "Dashboard",
                    // Ereur ajout d'un administrateur
    admin_email_exists: "This email already exists",
                     
                         
                                     
        
        







     
   
     
    
  },
  
  
   
  



  
  



  
  

 




















  // Version franaise de mon code
  FR: {
    app_name: "Otenti",
    about: "À propos",
    sales: "Pages de vente",
    articles: "Articles",
    support: "Support",
    contact: "Contact",
    search: "Recherche",
    home: "Accueil",
    products: "Produits",
    become_client: "Devenir Client",
    contact_us: "Contactez-nous",
    authentication: "Authentification",
    app_development: "Développement d'Application",
    security_consulting: "Conseil en Sécurité",
    user_training: "Formation Utilisateur",
    maintenance: "Maintenance",
    quick_links: "Liens Rapides",
    our_services: "Nos Services",
    location: "Ville, Pays",
    footer_description: "Votre partenaire de confiance pour des solutions innovantes et sécurisées.",
    all_rights_reserved: "Tous droits réservés",
    
    // Navbar and Footer translations (already existing)
    welcome: "Bienvenue",
    welcome_back: "Nous sommes ravis de vous revoir. Accédez à toutes vos fonctionnalités d'authentification.",
    features_title: "Fonctionnalités",
    features_subtitle: "Tout ce dont vous avez besoin pour l'authentification",
    cta_title: "Prêt à commencer ?",
    cta_button: "Commencer",
    auth: "Authentification Sécurisée",
    auth_desc: "Authentification multi-facteurs et protocoles de sécurité avancés pour protéger vos utilisateurs.",
    users: "Gestion des Utilisateurs",
    users_desc: "Outils complets pour gérer les rôles et permissions des utilisateurs.",
    security: "Sécurité Entreprise",
    security_desc: "Fonctionnalités de sécurité de niveau entreprise et conformité aux standards.",
    logout_title: "Confirmation de déconnexion",
    logout_message: "Êtes-vous sûr de vouloir vous déconnecter de votre compte ?",
    cancel: "Annuler",
    confirm: "Déconnexion",
    success_title: "Déconnexion réussie",
    success_message: "Vous avez été déconnecté avec succès.",
    admin_dashboard: "Tableau de bord Admin",
    sign_in: "Connexion",
    logout: "Déconnexion",
    
    // Hero Component
    title_part1: "Authentification Sécurisée",
    title_part2: "pour les Entreprises Modernes",
    description: "Otenti fournit des services d'authentification de niveau entreprise qui vous aident à sécuriser vos applications et à gérer efficacement l'accès des utilisateurs.",
    button: "Commencer",
    video_title: "Démo Otenti",
    video_description: "Découvrez à quel point il est facile d'intégrer notre système d'authentification sécurisé dans votre application.",
    video_error: "Votre navigateur ne peut pas lire cette vidéo",

  // Home Component
  go_to_dashboard: "Aller au tableau de bord",
  welcome_to_secure_authenticator: "Bienvenue dans un authentificateur plus sécurisé",
  authentication_authorization: "Authentification et Autorisation",
  safely_use_otenti: "Utilisez Otenti en toute sécurité comme fournisseur d'identité",
  define_access_level: "Définir le niveau d'accès à votre application",
  identify_inactive_users: "Identifier facilement les utilisateurs inactifs",
  identify_abused_authentications: "Identifier facilement les authentifications abusives",
  learn_more: "En savoir plus",
  optimize_costs_mitigate_losses: "Optimiser les coûts et réduire les pertes",
  one_password_for_all: "Vous pouvez utiliser en toute sécurité un seul mot de passe pour tous les logiciels auxquels vous devez accéder",
  rely_on_identity_provider: "S'appuyer sur un fournisseur d'identité entièrement construit et maintenu pour vous",
  password_cannot_be_stolen: "Votre mot de passe ne peut pas être volé",
  digital_in_dna: "Numérique dans l'ADN",
  digital_in_dna_description: "Nous sommes une start-up innovante avec les défis de la cybersécurité au cœur de notre ADN. Aujourd'hui, nous proposons un panel de services à tous les clients pour les aider à améliorer la sécurité de leurs données, les rendant ainsi plus conformes aux réglementations de sécurité nationales/internationales comme ISO, NIS, NIS2, ISAE, etc.",
  read_our_articles: "Lire nos articles",
  request_a_demo: "Demander une démo",
  cybersecurity_excellence: "Excellence en Cybersécurité",
  cybersecurity_excellence_description: "Notre expertise aide les entreprises à protéger leurs actifs numériques les plus précieux et à maintenir leur conformité avec les normes de sécurité en évolution.",
  our_trusted_partners: "Nos partenaires de confiance",

  // PartnersSlider Component
  they_trust_us: "Ils nous font",
  trust: "confiance",
  join_our_trusted_network: "Rejoignez notre réseau de partenaires de confiance",
  become_a_partner: "Devenir partenaire",

 

  // EntrepriseDashboard Component
  applications_management: "Gestion des applications",
  new_application: "Nouvelle application",
  add_administrator: "Ajouter un administrateur",
  total_applications: "Total des applications",
  total_users: "Total des utilisateurs",
  average_users_per_app: "Moyenne des utilisateurs par application",
  applications: "Applications",
  user_distribution_by_application: "Distribution des utilisateurs par application",
  export_csv: "Exporter en CSV",
  add_new_application: "Ajouter une nouvelle application",
  application_created_successfully: "Application créée avec succès !",
  failed_to_create_application: "Échec de la création de l'application. Veuillez réessayer.",
  administrator_added_successfully: "Administrateur ajouté avec succès !",
  no_data_to_export: "Aucune donnée disponible à exporter",
  data_exported_successfully: "Données exportées avec succès",
  application_name: "Nom de l'application",
  user_count: "Nombre d'utilisateurs",


  
   // DashboardApp Component
   dashboard: "Tableau de bord",
   error_company_id_not_found: "Erreur : ID de l'entreprise non trouvé.",
   error_loading_data: "Erreur lors du chargement des données.",
   user_activity_overview: "Aperçu de l'activité des utilisateurs",
   additional_insights: "Perspectives supplémentaires",
   blocked_accounts: "Comptes bloqués",
   connection_failures: "Échecs de connexion",
   new_users: "Nouveaux utilisateurs",



  // Users Component
  missing_company_or_app_id: "ID de l'entreprise ou de l'application manquant",
  user_deleted_successfully: "Utilisateur supprimé avec succès",
  error_deleting_user: "Erreur lors de la suppression",
  user_locked_successfully: "Utilisateur verrouillé avec succès",
  error_locking_user: "Erreur lors du verrouillage",
  user_unlocked_successfully: "Utilisateur déverrouillé avec succès",
  error_unlocking_user: "Erreur lors du déverrouillage",



  // Contact Component
  contact_us2: "Contactez-nous",
  name: "Nom",
  email: "Email",
  message: "Message",
  send: "Envoyer",
  sending: "Envoi en cours...",
  message_sent_successfully: "Votre message a été envoyé avec succès !",
  failed_to_send_message: "Échec de l'envoi du message. Veuillez réessayer plus tard.",
  our_information: "Nos informations",
  address: "123 Avenue Beige, Ville",
  phone: "(123) 456-7890",
  email_contact: "bonjour@exemple.com",
  

  // About Component
  about_otenti: "À propos d'Otenti",
  otenti_description: "Otenti est un leader innovant dans le domaine de la cybersécurité, spécialisé dans les solutions d'authentification de nouvelle génération. Notre vision est de rendre la sécurité numérique accessible et inviolable.",
  // our_services: "Nos services", //traduction deja presente
  leadership_quote: "La transformation numérique ouvre de nouvelles opportunités commerciales tout en introduisant de nouveaux risques. Notre mission est d'accompagner les organisations dans cette transformation en garantissant leur sécurité numérique.",
  ceo: "Directeur Général",
  ceo_bio: "xxx xxx dirige la transformation numérique et la stratégie de sécurité d'Otenti, avec plus de 15 ans d'expérience dans la cybersécurité.",
  cto: "Directeur Technique",
  cto_bio: "David supervise le développement technologique d'Otenti, spécialisé dans l'authentification avancée et la cryptographie.",
  cmo: "Directeur Marketing",
  cmo_bio: "Marie dirige la stratégie marketing globale d'Otenti, avec une expertise particulière dans le marketing B2B de la cybersécurité.",
  our_leadership_team: "Notre équipe de direction",
  leadership_team_description: "Rencontrez les experts derrière les solutions de sécurité innovantes d'Otenti",
  read_bio: "Lire la bio",
  free_demo: "Démo gratuite",
  free_demo_description: "Découvrez nos solutions en action avec une démonstration personnalisée",
  blog: "Blog",
  blog_description: "Obtenez les dernières informations sur la sécurité numérique",
  connect_with_otenti: "Connectez-vous avec Otenti",
  connect_description: "Découvrez comment nos solutions peuvent sécuriser votre transformation numérique",
  connect_on_linkedin: "Se connecter sur LinkedIn",
  biography: "Biographie",

  //about Complementaire 
  
  // About Component - Général
  close: "Fermer",
  // learn_more: "En savoir plus",
  cybersecurity: "Cybersécurité",
  view_bio: "Voir la biographie de {name}",

  // About Component - Notre Mission
  mission_description_new: "Vous offrir des solutions à la hauteur de vos besoins, innovantes, fiables, sophistiquées et de grande qualité.",
  mission_commitment_title: "Notre Engagement",
  mission_commitment_description: "En tant que l'un des produits de Tsuriel Cyber et IT, Otenti s'engage à fournir des services de cybersécurité de premier ordre, adaptés aux défis actuels et futurs du monde numérique.",
  mission_approach_title: "Notre Approche",
  mission_approach_description: "Chaque solution est conçue sur mesure, en tenant compte de vos spécificités et de vos objectifs commerciaux, pour garantir une protection optimale et une expérience utilisateur sans faille.",

  // About Component - Nos Valeurs
  our_values: "Nos Valeurs",
  values_description: "Un service à l'écoute de la clientèle basé sur la confiance et la confidentialité, la transparence, l'efficacité et le sens de la responsabilité.",
  value_customer_service_title: "Service à l'écoute",
  value_customer_service_description: "Un service centré sur le client, attentif à vos besoins spécifiques.",
  value_confidentiality_title: "Confidentialité",
  value_confidentiality_description: "Protection rigoureuse de vos données et informations sensibles.",
  value_transparency_title: "Transparence",
  value_transparency_description: "Communication claire et honnête tout au long de notre collaboration.",
  value_trust_title: "Confiance",
  value_trust_description: "Des relations basées sur la fiabilité et l'intégrité professionnelle.",
  value_responsibility_title: "Responsabilité",
  value_responsibility_description: "Un engagement total envers la qualité et la sécurité de nos solutions.",

  // About Component - Nos Services
  services_description: "Otenti est l'un des produits de Tsuriel Cyber et IT qui offre des services en Cybersécurité, Architecture, Data Security, Digitalisation, Audit, Design et Amélioration des Systèmes.",
  service_cybersecurity_title: "Cybersécurité",
  service_cybersecurity_description: "Protection avancée contre les menaces numériques et sécurisation de vos systèmes.",
  service_it_architecture_title: "Architecture IT",
  service_it_architecture_description: "Conception et implémentation d'infrastructures informatiques robustes et évolutives.",
  service_data_security_title: "Data Security",
  service_data_security_description: "Solutions spécialisées pour la protection et la gestion sécurisée de vos données.",
  service_digitalization_title: "Digitalisation",
  service_digitalization_description: "Transformation numérique adaptée à vos besoins spécifiques et à votre secteur d'activité.",
  service_audit_title: "Audit",
  service_audit_description: "Évaluation approfondie de vos systèmes pour identifier les vulnérabilités et opportunités d'amélioration.",
  service_design_title: "Design",
  service_design_description: "Conception d'interfaces intuitives et ergonomiques pour une expérience utilisateur optimale.",
  service_system_improvement_title: "Amélioration des Systèmes",
  service_system_improvement_description: "Optimisation de vos infrastructures existantes pour une performance et une sécurité accrues.",
  discover_all_services: "Découvrez tous nos services",

  // About Component - Contact CTA
  secure_digital_title: "Prêt à sécuriser votre environnement numérique ?",
  secure_digital_description: "Contactez-nous dès aujourd'hui pour une consultation personnalisée et découvrez comment Otenti peut transformer votre approche de la cybersécurité.",
  request_demo: "Demander une démo",

  // Clés existantes (exemples, à vérifier dans votre Translations.ts)
  // about_otenti: "À propos d'Otenti",
  // otenti_description: "...",
  // our_mission: "Notre Mission",
  // mission_description: "...",
  // our_services: "Nos Services",
  // contact_us: "Nous contacter",
  // core_value_security_title: "...",
  // core_value_security_description: "...",
  // core_value_trust_title: "...",
  // core_value_trust_description: "...",
  // core_value_innovation_title: "...",
  // core_value_innovation_description: "...",
  // learn_about_our_values: "En savoir plus sur nos valeurs",
  // leadership_quote: "...",
  // ceo: "PDG",
  // ceo_bio: "...",
  // cto: "Directeur Technique",
  // cto_bio: "...",
  // cmo: "Directeur Marketing",
  // cmo_bio: "...",
  // our_history: "Notre Histoire",
  // history_description: "...",
  // history_2020_title: "...",
  // history_2020_description: "...",
  // history_2022_title: "...",
  // history_2022_description: "...",
  // history_2024_title: "...",
  // history_2024_description: "...",
  // our_leadership_team: "Notre Équipe de Direction",
  // leadership_team_description: "...",
  // read_bio: "Lire la biographie",
  // connect_on_linkedin: "Se connecter sur LinkedIn",
  // biography: "Biographie",
  // connect_with_otenti: "Connectez-vous avec Otenti",
  // connect_description: "...",
  // free_demo: "Démo gratuite",
  // free_demo_description: "...",
  // contact_us: "Nous contacter",
  // contact_us_description: "...",
  // blog: "Blog",
  // blog_description: "...",
  // expertise_title: "...",
  // expertise_description: "...",
  // expertise_item_1: "...",
  // expertise_item_2: "...",
  // expertise_item_3: "...",
  // view_our_services: "Voir nos services",
  // contact_our_team: "Contacter notre équipe",
  // security_excellence_title: "...",
  // security_excellence_description: "...",


  // Sales Component
  our_solutions: "Nos solutions",
  solutions_description: "Choisissez le plan parfait pour les besoins de votre entreprise et évoluez en toute confiance",
  starter_plan: "Starter",
  starter_price: "49 €/mois",
  multi_factor_authentication: "Authentification multi-facteurs",
  up_to_1000_users: "Jusqu'à 1000 utilisateurs",
  email_support: "Support par email",
  basic_api_integration: "Intégration API basique",
  professional_plan: "Professionnel",
  professional_price: "199 €/mois",
  everything_from_starter: "Tout du Starter +",
  up_to_10000_users: "Jusqu'à 10 000 utilisateurs",
  support_24_7: "Support 24/7",
  sso_saml_integration: "Intégration SSO et SAML",
  advanced_analytics: "Analytique avancée",
  enterprise_plan: "Entreprise",
  enterprise_price: "Sur mesure",
  everything_from_professional: "Tout du Professionnel +",
  unlimited_users: "Utilisateurs illimités",
  dedicated_support: "Support dédié",
  on_premises_deployment: "Déploiement sur site",
  full_customization: "Personnalisation complète",
  subscribe: "S'abonner",
  payment_for: "Paiement pour {plan}",
  full_name: "Nom complet",
  card_number: "Numéro de carte",
  card_number_placeholder: "1234 5678 9012 3456",
  expiry_date: "Date d'expiration",
  expiry_date_placeholder: "MM/AA",
  cvv: "CVV",
  cvv_placeholder: "123",
  pay: "Payer {price}",
  processing: "Traitement en cours...",
  payment_secure: "Vos informations de paiement sont sécurisées et cryptées",
  payment_success: "Merci ! Votre abonnement à {plan} a été traité avec succès.",
  payment_failed: "Échec du traitement du paiement. Veuillez réessayer plus tard.",
  our_applications: "Nos applications",
  crm_pro: "CRM Pro",
  crm_pro_description: "Une solution complète pour la gestion de la relation client.",
  erp_suite: "Suite ERP",
  erp_suite_description: "Un logiciel puissant pour la gestion des ressources et de la production.",
  ecommerce_boost: "Boost E-Commerce",
  ecommerce_boost_description: "Optimisez votre boutique en ligne avec des outils avancés.",
  // learn_more: "En savoir plus", traduction existante
  custom_solution_title: "Besoin d'une solution personnalisée ?",
  custom_solution_description: "Notre équipe d'experts est prête à vous aider à construire la solution parfaite adaptée aux besoins spécifiques de votre entreprise",
  contact_our_team: "Contacter notre équipe",

  // Support Component
  support_center: "Centre de support Otenti",
  support_center_description: "Obtenez de l'aide avec nos solutions et services d'authentification",
  view_full_faq: "Voir la FAQ complète",
  start_live_chat: "Démarrer un chat en direct",
  support_status: "Statut du support : En ligne",
  avg_response_time: "Temps de réponse moyen : 2 heures",
  frequently_asked_questions: "Questions fréquemment posées",
  faq_mfa_question: "Comment configurer l'authentification à deux facteurs ?",
  faq_mfa_answer: "Pour configurer l'authentification à deux facteurs, accédez à Paramètres du compte > Sécurité > Authentification à deux facteurs et suivez les instructions à l'écran pour configurer votre méthode préférée.",
  faq_api_question: "Où trouver la documentation de l'API ?",
  faq_api_answer: "Notre documentation complète de l'API est disponible dans le portail des développeurs. Connectez-vous à votre compte, accédez à la section Développeurs et sélectionnez Documentation de l'API.",
  faq_password_question: "Comment réinitialiser mon mot de passe ?",
  faq_password_answer: "Pour réinitialiser votre mot de passe, cliquez sur le lien 'Mot de passe oublié' sur la page de connexion. Vous recevrez un email avec des instructions pour créer un nouveau mot de passe.",
  support_tickets: "Tickets de support",
  create_ticket: "Créer un ticket",
  my_tickets: "Mes tickets",
  create_new_ticket: "Créer un nouveau ticket de support",
  tips_for_resolution: "Conseils pour une résolution rapide",
  tip_describe_problem: "Décrivez clairement votre problème avec tous les détails pertinents.",
  tip_include_screenshots: "Incluez des captures d'écran ou des messages d'erreur si applicable.",
  tip_list_steps: "Listez les étapes que vous avez déjà suivies pour résoudre le problème.",
  subject: "Sujet",
  subject_placeholder: "Brève description de votre problème",
  detailed_description: "Description détaillée",
  description_placeholder: "Veuillez fournir autant de détails que possible...",
  priority: "Priorité",
  priority_low: "Basse",
  priority_medium: "Moyenne",
  priority_high: "Haute",
  category: "Catégorie",
  category_technical: "Problème technique",
  category_billing: "Question de facturation",
  category_feature: "Demande de fonctionnalité",
  category_other: "Autre",
  submit_ticket: "Soumettre le ticket de support",
  ticket_submitted_success: "Ticket soumis avec succès !",
  all_tickets: "Tous les tickets",
  open_tickets: "Ouverts",
  resolved_tickets: "Résolus",
  no_tickets_found: "Aucun ticket trouvé",
  no_tickets_message: "Aucun ticket ne correspond à vos critères de filtrage actuels.",
  status_open: "Ouvert",
  status_resolved: "Résolu",
  ticket_number: "Ticket #{id}",
  created_on: "Créé le {date}",
  update_ticket: "Mettre à jour",
  close_ticket: "Fermer",
  support_response: "Réponse du support",
  pdf_document: "Document PDF • 2,4 Mo",
  view: "Voir",
  download: "Télécharger",
  response_helpful: "Cette réponse vous a-t-elle été utile ?",
  click_to_rate: "Cliquez pour évaluer",
  contact_us_directly: "Contactez-nous directement",
  phone_support: "Support téléphonique",
  // email_support: "Support par email", traduction existante
  start_live_chat_now: "Démarrer un chat en direct maintenant",
  support_hours: "Horaires de support",
  monday_friday: "Lundi - Vendredi",
  monday_friday_hours: "9h00 - 18h00",
  saturday: "Samedi",
  saturday_hours: "10h00 - 16h00",
  sunday: "Dimanche",
  sunday_hours: "Fermé",
  emergency_support: "Support d'urgence",
  emergency_support_description: "Pour les problèmes critiques en dehors des heures ouvrables, les clients premium peuvent accéder à notre support d'urgence 24/7.",
  learn_premium_support: "En savoir plus sur le support premium",
  ticket_mfa_subject: "Problème de configuration MFA",
  ticket_mfa_description: "Je ne peux pas configurer l'authentification à deux facteurs...",
  ticket_mfa_response: "Voici les étapes pour résoudre votre problème de configuration MFA...",
  ticket_api_subject: "Documentation API",
  ticket_api_description: "Demande de documentation détaillée pour l'intégration API",
  ticket_api_response_content: "Documentation_API_Otenti.pdf",


  article_tsuriel_title: "Sécuriser vos données avec Tsuriel Authentication",
  article_tsuriel_description: "Une analyse approfondie des fonctionnalités de sécurité avancées de notre solution d'authentification.",
  article_tsuriel_date: "18 janvier 2025",
  article_tsuriel_content: `
    # Sécuriser vos données avec Tsuriel Authentication

    Notre solution Tsuriel Authentication représente l'état de l'art en matière de sécurité d'authentification. Voici une analyse détaillée des fonctionnalités qui la distinguent.

    ## Architecture de sécurité avancée

    Tsuriel Authentication utilise une architecture zero-trust avec chiffrement de bout en bout. Toutes les données sont chiffrées en transit et au repos avec les algorithmes les plus récents reconnus par l'industrie.

    ## Fonctionnalités clés

    1. **Authentification contextuelle**
       Notre système évalue en temps réel le niveau de risque de chaque tentative de connexion en analysant de multiples facteurs : localisation, appareil, comportement utilisateur, etc.

    2. **Biométrie de nouvelle génération**
       Au-delà des empreintes digitales, notre solution intègre la reconnaissance faciale 3D, la reconnaissance vocale et même l'analyse comportementale.

    3. **Gestion centralisée des politiques**
       Une console d'administration intuitive permet de définir des politiques d'accès granulaires adaptées à différents groupes d'utilisateurs.

    ## Études de cas

    Nos clients ont constaté :
    - Réduction de 95 % des incidents de sécurité liés à l'authentification
    - Diminution de 60 % des appels au support pour réinitialisation de mots de passe
    - Augmentation de la satisfaction utilisateur de 25 % grâce à des processus de connexion plus fluides

    Découvrez comment Tsuriel Authentication peut transformer votre stratégie de sécurité en prenant rendez-vous avec l'un de nos experts.
  `,
  article_ux_security_title: "Comment améliorer l'expérience utilisateur tout en renforçant la sécurité",
  article_ux_security_description: "Les meilleures pratiques pour maintenir un équilibre entre sécurité et facilité d'utilisation.",
  article_ux_security_date: "15 janvier 2025",
  article_ux_security_content: `
    # Comment améliorer l'expérience utilisateur tout en renforçant la sécurité

    L'équilibre entre sécurité robuste et expérience utilisateur fluide est souvent perçu comme un défi insurmontable. Pourtant, les approches modernes démontrent qu'il est possible d'atteindre ces deux objectifs simultanément.

    ## Le faux dilemme de la sécurité vs. expérience

    Historiquement, plus de sécurité signifiait plus de friction pour l'utilisateur. Aujourd'hui, les technologies intelligentes permettent d'adapter dynamiquement les niveaux de sécurité en fonction du contexte, réduisant la friction dans les scénarios à faible risque.

    ## Stratégies efficaces

    ### 1. Authentification progressive
    Commencez avec une méthode simple, puis ajoutez des facteurs uniquement lorsque le contexte l'exige (opération sensible, comportement inhabituel).

    ### 2. Biométrie transparente
    Les technologies biométriques modernes peuvent fonctionner en arrière-plan sans intervention active de l'utilisateur.

    ### 3. Single Sign-On (SSO) sécurisé
    Permettez aux utilisateurs d'accéder à plusieurs applications avec une seule authentification forte, plutôt que de mémoriser de multiples identifiants.

    ## Résultats concrets

    Les entreprises ayant adopté ces approches ont observé :
    - Augmentation du taux d'adoption des solutions par les utilisateurs (+35 %)
    - Diminution des contournements de sécurité par les employés (-40 %)
    - Meilleure perception des politiques de sécurité au sein de l'organisation

    Notre équipe peut vous accompagner dans l'implémentation de ces stratégies pour transformer la sécurité d'un obstacle perçu à un avantage compétitif.
  `,
  // SearchPage Component
  advanced_search: "Recherche avancée",
  search_placeholder: "Rechercher...",
  search_button: "Rechercher",
  loading: "Chargement...",
  no_results_found: "Aucun résultat trouvé pour \"{query}\"",
  category_all: "Tous",
  category_Application: "Application",
  category_users: "Utilisateurs",
  category_Articles: "Articles",
  category_documents: "Documents",
  search_result_tech_company_title: "Entreprise technologique",
  search_result_tech_company_description: "Solutions technologiques pour entreprises",
  search_result_ibro_title: "Ibro",
  search_result_ibro_description: "Ingénieur logiciel chez Entreprise technologique",
  search_result_project_proposal_title: "Proposition de projet",
  search_result_project_proposal_description: "Documentation technique pour un nouveau projet",

  // BecomeClient Component
  become_client_title: "Devenir client",
  become_client_description: "Remplissez les informations suivantes pour soumettre votre demande",
  watch_demonstration: "Voir la démonstration",
  demo_modal_title: "Besoin d'aide pour l'inscription ?",
  demo_modal_description: "Voulez-vous voir une vidéo de démonstration expliquant comment remplir votre demande d'inscription ?",
  demo_modal_skip: "Non, merci",
  demo_modal_watch: "Regarder la démo",
  demo_video_title: "Comment devenir client",
  demo_video_description: "Cette vidéo vous guide à travers le processus d'inscription client.",
  start_registration: "Commencer l'inscription",
  step_information: "Informations",
  step_plan: "Plan",
  step_confirmation: "Confirmation",
  company_information: "Informations sur l'entreprise",
  choose_plan: "Choisissez votre plan",
  request_sent_success: "Demande envoyée avec succès !",
  request_review_message: "Notre équipe examinera votre demande et vous contactera sous peu.",
  back_to_homepage: "Retour à l'accueil",
  error_registering_company: "Erreur lors de l'enregistrement de l'entreprise",
  
  // RolesPage Component
  roles_management: "Gestion des rôles",
  add_role: "Ajouter un rôle",
  role_name: "Nom du rôle",
  actions: "Actions",
  edit_role: "Modifier le rôle",
  delete_role: "Supprimer le rôle",
  open_menu: "Ouvrir le menu",
  add_new_role: "Ajouter un nouveau rôle",
  enter_role_name: "Entrez le nom du rôle",
  edit_role_name: "Modifier le nom du rôle",
  no_roles_available: "Aucun rôle disponible",
  role_added_success: "Rôle ajouté avec succès",
  role_modified_success: "Rôle modifié avec succès",
  role_deleted_success: "Rôle supprimé avec succès",
  error_loading_roles: "Erreur lors du chargement des rôles",
  error_adding_role: "Erreur lors de l'ajout du rôle",
  error_modifying_role: "Erreur lors de la modification du rôle",
  error_deleting_role: "Erreur lors de la suppression du rôle",
  unexpected_response_format: "Format de réponse inattendu",
  add: "Ajouter",
  save: "Enregistrer",
  // cancel: "Annuler",traduction deja present

  // Sidebar Component
  menu: "Menu",
  nav_home: "Accueil",
  nav_applications: "Applications",
  nav_administrator: "Administrateur",
  nav_settings: "Paramètres",
  expand_sidebar: "Déplier la barre latérale",
  collapse_sidebar: "Replier la barre latérale",



  // SidebarApp Component
  app_secure_by_otenti: "Application sécurisée par Otenti",
  nav_dashboard: "Tableau de bord",
  nav_users: "Utilisateurs",
  nav_roles: "Rôles",
  nav_support: "Support",
  // nav_settings: "Paramètres", // Déjà défini dans Sidebar.tsx
  // expand_sidebar: "Déplier la barre latérale", // Déjà défini dans Sidebar.tsx
  // collapse_sidebar: "Replier la barre latérale", // Déjà défini dans Sidebar.tsx

  // UserList Component
  users_list: "Liste des utilisateurs",
  search_users: "Rechercher des utilisateurs...",
  add_users: "Ajouter des utilisateurs",
  loading_users: "Chargement des utilisateurs...",
  error_loading_users: "Erreur lors du chargement des utilisateurs",
  // email: "Email",
  // full_name: "Nom complet",
  status: "Statut",
  // actions: "Actions",
  details: "Détails",
  // add_role: "Ajouter un rôle",
  edit: "Modifier",
  lock: "Verrouiller",
  unlock: "Déverrouiller",
  delete: "Supprimer",
  view_details: "Voir les détails",
  status_active: "Actif",
  status_locked: "Verrouillé",
  add_role_to_user: "Ajouter un rôle à {user}",
  select_role: "Sélectionner un rôle",
  select_role_placeholder: "Sélectionner un rôle",
  please_select_role: "Veuillez sélectionner un rôle",
  // role_added_success: "Rôle ajouté avec succès",
  // error_loading_roles: "Échec du chargement des rôles",
  error_loading_roles_log: "Erreur lors du chargement des rôles",
  // error_adding_role: "Échec de l'ajout du rôle",
  error_adding_role_log: "Erreur lors de l'ajout du rôle",
  // add: "Ajouter", // Déjà défini dans RolesPage.tsx
  // cancel: "Annuler", // Déjà défini dans RolesPage.tsx
  // roles: "Rôles", // Déjà défini dans RolesPage.tsx

  

// UserDetails Component
user_details: "Détails de l'utilisateur",
last_activity: "Dernière activité",
last_login: "Dernière connexion",
not_available: "N/D",
// close: "Fermer",
// delete_role: "Supprimer ce rôle", déja existant
error_deleting_role_log: "Erreur lors de la suppression du rôle",
// email: "Email", // Déjà défini dans UserList.tsx
// full_name: "Nom complet", // Déjà défini dans UserList.tsx
// status: "Statut", // Déjà défini dans UserList.tsx
// roles: "Rôles", // Déjà défini dans UserList.tsx
// status_active: "Actif", // Déjà défini dans UserList.tsx
// status_locked: "Verrouillé", // Déjà défini dans UserList.tsx
// role_deleted_success: "Rôle supprimé avec succès", // Déjà défini dans RolesPage.tsx
// error_deleting_role: "Échec de la suppression du rôle", // Déjà défini dans RolesPage.tsx
 // Dans Translation.ts, ajouter ces clés dans chaque section de langue (EN, FR, ES)





  // UserFormModal Component
  new_user: "Nouvel utilisateur",
  edit_user: "Modifier l'utilisateur",
  email_placeholder: "email@exemple.com",
  full_name_placeholder: "Prénom Nom",
  update: "Modifier",
  user_added_success: "Utilisateur ajouté avec succès",
  user_updated_success: "Utilisateur modifié avec succès",
  error_user_action: "Erreur lors de {action} de l'utilisateur",
  adding: "l'ajout",
  updating: "la modification",
  // email: "Email", // Déjà défini dans UserList.tsx
  // full_name: "Nom complet", // Déjà défini dans UserList.tsx
  // roles: "Rôles", // Déjà défini dans UserList.tsx
  // add: "Ajouter", // Déjà défini dans RolesPage.tsx
  // cancel: "Annuler", // Déjà défini dans RolesPage.tsx
  // close: "Fermer", // Déjà défini dans UserDetails.tsx
// Anglais (EN)



  // ApplicationFileUpload Component
  drag_drop_csv: "Glissez et déposez un fichier CSV ici, ou cliquez pour sélectionner",
  drop_csv: "Déposez le fichier CSV ici...",
  scanning_file: "Analyse du fichier pour la sécurité...",
  download_template: "Télécharger le modèle",
  template_filename: "modèle_rôles_application.csv",
  file_constraints: "Taille maximale : 1 Mo • Seuls les fichiers CSV simples sont acceptés",
  error_no_file_selected: "Aucun fichier sélectionné",
  error_only_csv: "Seuls les fichiers CSV sont acceptés",
  error_invalid_file_type: "Type de fichier invalide",
  error_security_risk: "Fichier rejeté : risque de sécurité potentiel détecté",
  error_invalid_csv_structure: "Structure CSV invalide. Doit contenir une colonne 'Rôle'",
  error_no_valid_roles: "Aucun rôle valide trouvé dans le fichier CSV",
  error_parsing_csv: "Erreur lors de l'analyse du fichier CSV",
  error_invalid_csv: "Fichier CSV invalide",



  // SettingApp Component
  settings: "Paramètres",
  // loading: "Chargement...",
  error_loading: "Erreur lors du chargement des données",
  // description: "Description",
  no_description: "Aucune description",
  client_id: "ID Client",
  // status: "Statut",
  // status_active: "Actif",
  status_inactive: "Inactif", // Ajouté pour d'autres statuts possibles
  copy: "Copier",
  copy_application_name: "Copier le nom de l'application",
  copy_client_id: "Copier l'ID client",
  copy_redirect_uri: "Copier l'URI de redirection",
  // edit: "Modifier",
  edit_status: "Modifier le statut",
  status_edit_alert: "La fonctionnalité de modification du statut n'est pas encore implémentée",
  delete_app: "Supprimer l'application",
  update_settings: "Mettre à jour les paramètres",
  confirm_deletion: "Confirmer la suppression",
  delete_confirmation: "Voulez-vous vraiment supprimer '{appName}' ? Cette action est irréversible.",
  error_delete_app_log: "Erreur lors de la suppression de l'application",
  error_update_app_log: "Erreur lors de la mise à jour de l'application",
  edit_application: "Modifier l'application",
  post_logout_redirect_uris: "URIs de redirection après déconnexion",
copy_post_logout_redirect_uris: "Copier les URIs de redirection après déconnexion",
no_post_logout_redirect_uris: "Aucune URI de redirection après déconnexion spécifiée",
active: "Actif",
blocked: "Bloqué",
  // Réutilisées :
  // application_name: "Nom de l'application", // Depuis ApplicationForm.tsx
  // redirect_uri: "URI de redirection", // Depuis ApplicationForm.tsx
  // cancel: "Annuler", // Depuis UserFormModal.tsx, ApplicationForm.tsx
  // delete: "Supprimer", // Depuis UserList.tsx, UserDetails.tsx
  // save: "Enregistrer", // Depuis UserFormModal.tsx

  


  // AddRoleModal Component
  // add_new_role: "Ajouter un nouveau rôle",
  // role_name: "Nom du rôle",
  // enter_role_name: "Entrez le nom du rôle",
  // add: "Ajouter",
  // add_role: "Ajouter le rôle",
  error_add_role_log: "Erreur lors de l'ajout du rôle",
  // Réutilisée :
  // cancel: "Annuler", // Depuis UserFormModal.tsx, ApplicationForm.tsx, SettingApp.tsx
  


  // LandingPage - Général
  percentage: "%",
  no_data_available: "Aucune donnée disponible pour la période sélectionnée",
  failed_to_load_data: "Échec du chargement des données des applications. Veuillez réessayer plus tard.",
  // view_details: "Voir les détails pour {title}",

  // Périodes
  period: "Période",
  select_period: "Sélectionner une période",
  select_option: "Sélectionner {label}",
  months: " 3 mois",
  monthss: " 6 mois",

  // 6_months: "6 mois",
  year: "1 an",
  all_time: "Tout le temps",

  // Menu
  // menu: "Menu",
  dashboard_company: "Tableau de bord de l'entreprise",
  generate_new_key: "Générer une nouvelle clé",
  request_registration: "Demander une inscription",
  edit_notification_list: "Modifier la liste des notifications",
  // settings: "Paramètres",

  // Export
  global_export: "Exportation globale",
  global_export_description: "Exporter les statistiques complètes de l'entreprise, y compris toutes les applications et données des utilisateurs.",
  export_full_report: "Exporter le rapport complet (CSV)",
  preparing_data: "Préparation des données...",
  no_data_for_export: "Aucune donnée disponible pour l'exportation dans la période sélectionnée.",
  company_stats_report: "rapport-stats-entreprise",
  application: "Application",
  authentication_rate: "Taux d'authentification",
  failed_logins: "Échecs de connexion",
  locked_accounts: "Comptes verrouillés",
  inactive_users: "Utilisateurs inactifs",

  // CompanyStatsChart
  statistics_over: "Statistiques sur {period}",
  authentication_rate_by_app: "Taux d'authentification par application",
  login_failures_by_app: "Échecs de connexion par application",
  locked_accounts_by_app: "Comptes verrouillés par application",
  user_inactivity_by_app: "Inactivité des utilisateurs par application",
  low_authentication_warning: "Certaines applications ont des taux d'authentification faibles",
  high_failure_warning: "Certaines applications ont des taux d'échec élevés",
  high_lock_warning: "Certaines applications ont des taux de verrouillage élevés",
  high_inactivity_warning: "Certaines applications ont des taux d'inactivité élevés",

  // StatSummaryCard
  from_previous_period: "par rapport à la période précédente",

  // AnalyticsHub
  analytics_hub: "Centre d'analyse",
  analytics_hub_description: "Tableau de bord interactif pour surveiller les performances de sécurité des applications",
  overview: "Aperçu",
  security_status: "État de sécurité",
  user_activity: "Activité des utilisateurs",

  // AnalyticsHub - Overview
  apps_performance_summary: "Résumé des performances des applications",
  quick_insights: "Aperçus rapides",
  low_authentication_insight: "Les taux d'authentification sont en dessous de l'objectif. Envisagez une formation des utilisateurs ou des flux d'authentification simplifiés.",
  high_failure_insight: "Taux d'échec élevés détectés. Vérifiez les problèmes de sécurité potentiels ou les problèmes d'interface utilisateur.",
  high_lockout_insight: "Verrouillages de comptes élevés, indiquant des tentatives possibles de force brute ou des problèmes de mot de passe utilisateur.",
  high_inactivity_insight: "Taux d'inactivité élevés des utilisateurs. Envisagez des campagnes d'engagement ou un nettoyage des comptes.",
  healthy_metrics_insight: "Toutes les métriques des applications sont dans des plages saines. Continuez à surveiller pour une sécurité optimale.",
  recommended_actions: "Actions recommandées",
  view_all_recommendations: "Voir toutes les recommandations",
  manage_users: "Gérer les utilisateurs",
  manage_users_description: "Configurer les contrôles d'accès et les permissions des utilisateurs",
  security_settings: "Paramètres de sécurité",
  security_settings_description: "Examiner et mettre à jour les politiques de sécurité",
  notifications: "Notifications",
  notifications_description: "Configurer les alertes de sécurité et d'activité",

  // AnalyticsHub - Security Status
  security_status_overview: "Aperçu de l'état de sécurité",
  auth_status_distribution: "Distribution de l'état d'authentification",
  security_risk_assessment: "Évaluation des risques de sécurité",
  authentication_health: "Santé de l'authentification",
  login_failures: "Échecs de connexion",
  account_lockouts: "Verrouillages de compte",
  // user_activity: "Activité des utilisateurs",
  review_security_settings: "Revoir les paramètres de sécurité",
  authenticated: "Authentifié",
  locked: "Verrouillé",
  inactive: "Inactif",

  // AnalyticsHub - User Activity
  user_activity_metrics: "Métriques d'activité des utilisateurs",
  active_vs_inactive_users: "Utilisateurs actifs vs inactifs par application",
  active_users: "Utilisateurs actifs %",
  user_engagement_summary: "Résumé de l'engagement des utilisateurs",
  user_engagement_description: "Les applications affichent en moyenne {active}% d'utilisateurs actifs contre {inactive}% d'utilisateurs inactifs.",
  security_event_summary: "Résumé des événements de sécurité",
  security_event_description: "Les applications affichent en moyenne {failed}% d'échecs de connexion et {locked}% de comptes verrouillés.",
  configure_alerts: "Configurer les alertes",

  // FailedLoginsChart
  // percentage: "%",
  // loading: "Chargement...",
  // error_loading: "Erreur lors du chargement des données",
  download_error: "Une erreur s'est produite lors du téléchargement",
  login_failure_statistics: "Statistiques des échecs de connexion",
  // select_period: "Sélectionner une période",
  // select_option: "Sélectionner {label}",
  Hours24: "24 heures",
  days7: "7 jours",
  days30: "30 jours",
  days90: "90 jours",
  // download: "Télécharger",
  png: "PNG",
  download_png: "Télécharger en PNG",
  jpeg: "JPEG",
  download_jpeg: "Télécharger en JPEG",
  pdf: "PDF",
  download_pdf: "Télécharger en PDF",
  failed_logins_period: "Échecs ({period})",
  successful_logins: "Connexions réussies",
  failed_login_summary: "{percentage}% des utilisateurs ({count}/{totalUsers}) ont rencontré des échecs de connexion au cours des derniers {period}.",
  // high_failure_warning: "Avertissement : Taux d'échec anormalement élevé",
  login_failure_kpi: "KPI-échec-connexion",

  
  // InactiveUsersChart
  // percentage: "%",
  // loading: "Chargement...",
  // error_loading: "Erreur lors du chargement des données",
  // download_error: "Une erreur s'est produite lors du téléchargement",
  user_inactivity_status: "Statut d'inactivité des utilisateurs",
  // select_period: "Sélectionner une période",
  // select_option: "Sélectionner {label}",
  // days30: "30 jours",
  days60: "60 jours",
  // days90: "90 jours",
  days180: "180 jours",
  // download: "Télécharger",
  // png: "PNG",
  // download_png: "Télécharger en PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Télécharger en JPEG",
  // pdf: "PDF",
  // download_pdf: "Télécharger en PDF",
  inactive_users_period: "Inactifs ({period}+)",
  // active_users: "Utilisateurs actifs",
  inactive_user_summary: "{percentage}% des utilisateurs ({count}/{totalUsers}) sont inactifs depuis plus de {period}.",
  recently_inactive_summary: "{count} utilisateurs sont devenus inactifs durant cette période.",
  // high_inactivity_warning: "Avertissement : Un taux d'inactivité élevé peut indiquer des comptes inutilisés",
  inactive_users_kpi: "KPI-utilisateurs-inactifs",

  
  // LockedUsersChart
  // percentage: "%",
  // loading: "Chargement...",
  // error_loading: "Erreur lors du chargement des données",
  // download_error: "Une erreur s'est produite lors du téléchargement",
  account_lock_status: "Statut de verrouillage des comptes",
  // select_period: "Sélectionner une période",
  // select_option: "Sélectionner {label}",
  // Hours24: "24 heures",
  // days7: "7 jours",
  // days30: "30 jours",
  // all_time: "Tout le temps",
  // download: "Télécharger",
  // png: "PNG",
  // download_png: "Télécharger en PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Télécharger en JPEG",
  // pdf: "PDF",
  // download_pdf: "Télécharger en PDF",
  locked_users: "Utilisateurs verrouillés",
  // active_users: "Utilisateurs actifs",
  locked_user_summary: "{percentage}% des comptes ({count}/{totalUsers}) sont actuellement verrouillés.",
  recent_locks_summary: "{count} comptes ont été verrouillés au cours des derniers {period}.",
  // high_lock_warning: "Avertissement : Un taux de verrouillage élevé peut indiquer des problèmes de sécurité",
  locked_users_kpi: "KPI-utilisateurs-verrouillés",

  
  // AuthPercentageChart
  // percentage: "%",
  // loading: "Chargement...",
  // error_loading: "Erreur lors du chargement des données",
  // download_error: "Une erreur s'est produite lors du téléchargement",
  user_authentication_rate: "Taux d'authentification des utilisateurs",
  // select_period: "Sélectionner une période",
  // select_option: "Sélectionner {label}",
  // days7: "7 jours",
  //  days30: "30 jours",
  // days90: "90 jours",
  // days180: "180 jours",
  // download: "Télécharger",
  // png: "PNG",
  // download_png: "Télécharger en PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Télécharger en JPEG",
  // pdf: "PDF",
  // download_pdf: "Télécharger en PDF",
  authenticated_users_period: "Authentifiés ({period})",
  not_authenticated_users: "Non authentifiés",
  auth_summary: "{percentage}% des utilisateurs se sont authentifiés au cours des derniers {period}.",
  low_auth_warning: "Avertissement : Un faible taux d'authentification peut indiquer des utilisateurs inactifs",
  authentication_kpi: "KPI-authentification",

  


  // FAQ
  faq: "FAQ",
  // frequently_asked_questions: "Questions fréquemment posées",
  faq_subtitle: "Trouvez des réponses aux questions les plus courantes sur nos services d'authentification",
  expand_faq: "Déplier {question}",
  collapse_faq: "Replier {question}",
  // faq_mfa_question: "Qu'est-ce que l'authentification multi-facteurs (MFA) ?",
  // faq_mfa_answer: "L'authentification multi-facteurs est une méthode de sécurité qui exige que les utilisateurs fournissent deux preuves d'identité différentes ou plus pour accéder à un compte. Otenti propose plusieurs options MFA, y compris SMS, applications d'authentification et clés de sécurité physiques.",
  faq_data_protection_question: "Comment Otenti protège-t-il les données de mes utilisateurs ?",
  faq_data_protection_answer: "Otenti utilise un chiffrement de bout en bout, stocke les données dans des centres de données sécurisés et suit les meilleures pratiques de l'industrie pour la sécurité. Nous respectons le RGPD, le CCPA et d'autres réglementations importantes en matière de protection des données.",
  faq_customization_question: "Puis-je personnaliser l'interface d'authentification ?",
  faq_customization_answer: "Oui, Otenti offre des options de personnalisation complètes. Vous pouvez adapter l'interface aux couleurs de votre marque, modifier les flux d'authentification et personnaliser les messages pour vos utilisateurs.",
  faq_uptime_question: "Quels sont les taux de disponibilité du service ?",
  faq_uptime_answer: "Otenti garantit une disponibilité du service de 99,99 %. Nous maintenons une infrastructure redondante et surveillons nos systèmes 24/7 pour assurer une authentification fiable à tout moment.",
  faq_integration_question: "Comment intégrer Otenti à mon application existante ?",
  faq_integration_answer: "Otenti fournit des SDK et des API faciles à intégrer pour les principales plates-formes et langages de programmation. Notre documentation détaillée et notre équipe de support technique vous guideront tout au long du processus d'intégration.",
  faq_support_question: "Quel support technique est disponible ?",
  faq_support_answer: "Nous offrons un support technique 24/7 pour les clients entreprise, avec des temps de réponse garantis selon votre niveau de service. Notre équipe d'experts est disponible par e-mail, chat et téléphone.",
  faq_user_management_question: "Comment gérer les utilisateurs et leurs permissions ?",
  faq_user_management_answer: "Otenti propose un tableau de bord d'administration complet pour gérer les utilisateurs, les rôles et les permissions. Vous pouvez facilement ajouter/supprimer des utilisateurs, définir des politiques de sécurité et suivre les activités.",
  faq_pricing_question: "Quelles sont les options de tarification ?",
  faq_pricing_answer: "Nous proposons plusieurs forfaits adaptés aux besoins des entreprises de toutes tailles, des startups aux grands comptes. Contactez notre équipe commerciale pour un devis personnalisé selon vos besoins spécifiques.",


  // NotFound
  not_found_title: "404 - Page non trouvée",
  not_found_message: "La page que vous recherchez n'existe pas.",
  back_to_home: "Retour à l'accueil",

  
    video_tutorials: "Tutoriels Vidéo",
    integration_tutorials: "Tutoriels d'Intégration",
    usage_tutorials: "Tutoriels d'Utilisation",
    watch_tutorial: "Voir le Tutoriel",
    video_not_supported: "Votre navigateur ne supporte pas la lecture vidéo.",
    tutorial_react_integration_title: "Intégrer Otenti avec son Application React",
    tutorial_react_integration_desc: "Guide complet pour connecter votre application React à Otenti",
    tutorial_nodejs_auth_title: "Authentification sur Application Node.js",
    tutorial_nodejs_auth_desc: "Procédure de configuration de l'authentification pour les applications Node.js",
    tutorial_angular_mfa_title: "Mise en place MFA avec Angular",
    tutorial_angular_mfa_desc: "Configuration de l'authentification multi-facteurs pour les projets Angular",
    tutorial_user_management_title: "Gestion des Utilisateurs dans Otenti",
    tutorial_user_management_desc: "Apprenez à gérer les utilisateurs et les permissions dans le tableau de bord Otenti",
    tutorial_dashboard_usage_title: "Utilisation du Tableau de Bord Otenti",
    tutorial_dashboard_usage_desc: "Guide pour naviguer et utiliser le tableau de bord d'administration Otenti",

          
// TUTORIEL VIDEO SECTION
    // video_tutorials: 'Tutoriels vidéo',
    // integration_tutorials: 'Tutoriels d\'intégration',
    // usage_tutorials: 'Tutoriels d\'utilisation',
    // watch_tutorial: 'Regarder le tutoriel',
    // video_not_supported: 'Votre navigateur ne prend pas en charge la lecture de vidéos.',
    
    // // Titres des tutoriels d'intégration
    // tutorial_react_integration_title: 'Tutoriel d\'intégration React',
    // tutorial_nodejs_auth_title: 'Tutoriel d\'authentification Node.js',
    // tutorial_angular_mfa_title: 'Tutoriel d\'authentification MFA avec Angular',
    tutorial_vue_integration_title: 'Tutoriel d\'intégration Vue.js',
    tutorial_flutter_integration_title: 'Tutoriel d\'intégration Flutter',
    
    // Descriptions des tutoriels d'intégration
    // tutorial_react_integration_desc: 'Apprenez à intégrer l\'authentification Otenti avec votre application React en quelques étapes simples.',
    // tutorial_nodejs_auth_desc: 'Configurez l\'authentification sécurisée dans votre backend Node.js avec notre API Otenti.',
    // tutorial_angular_mfa_desc: 'Implémentez l\'authentification à facteurs multiples dans votre application Angular pour une sécurité renforcée.',
    tutorial_vue_integration_desc: 'Guide complet pour intégrer l\'authentification Otenti dans votre projet Vue.js.',
    tutorial_flutter_integration_desc: 'Configurez l\'authentification Otenti dans votre application mobile Flutter en quelques minutes.',
    
    // URLs des vidéos d'intégration
    tutorial_react_integration_video: '/videos/otenti-react-integration_fr.mp4',
    tutorial_nodejs_auth_video: '/videos/otenti-nodejs-auth_fr.mp4',
    tutorial_angular_mfa_video: '/videos/otenti-angular-mfa_fr.mp4',
    tutorial_vue_integration_video: '/videos/otenti-vue-integration_fr.mp4',
    tutorial_flutter_integration_video: '/videos/otenti-flutter-integration_fr.mp4',
    
    // URLs des miniatures d'intégration
    tutorial_react_integration_thumbnail: '/thumbnails/react-integration_fr.jpg',
    tutorial_nodejs_auth_thumbnail: '/thumbnails/nodejs-auth_fr.jpg',
    tutorial_angular_mfa_thumbnail: '/thumbnails/angular-mfa_fr.jpg',
    tutorial_vue_integration_thumbnail: '/thumbnails/vue-integration_fr.jpg',
    tutorial_flutter_integration_thumbnail: '/thumbnails/flutter-integration_fr.jpg',
    
    // Titres des tutoriels d'utilisation
    tutorial_create_application: 'Créer une nouvelle application',
    tutorial_add_user: 'Ajouter et gérer des utilisateurs',
    tutorial_add_role: 'Configuration des rôles et permissions',
    tutorial_user_management: 'Gestion des comptes utilisateurs',
    tutorial_chart_usage: 'Utilisation des tableaux de bord et statistiques',
    
    // Descriptions des tutoriels d'utilisation
    tutorial_create_application_desc: 'Découvrez comment créer et configurer une nouvelle application dans le portail Otenti.',
    tutorial_add_user_desc: 'Apprenez à ajouter des utilisateurs à votre application et à gérer leurs informations.',
    tutorial_add_role_desc: 'Guide pour configurer des rôles personnalisés et attribuer des permissions spécifiques.',
    // tutorial_user_management_desc: 'Gérez efficacement les comptes utilisateurs, les sessions actives et les accès à votre application.',
    tutorial_chart_usage_desc: 'Maîtrisez l\'utilisation des graphiques et tableaux de bord pour suivre l\'activité de votre application.',
    
    // URLs des vidéos d'utilisation
    tutorial_create_application_video: '/videos/otenti-create-application_fr.mp4',
    tutorial_add_user_video: '/videos/otenti-add-user_fr.mp4',
    tutorial_add_role_video: '/videos/otenti-add-role_fr.mp4',
    tutorial_user_management_video: '/videos/otenti-user-management_fr.mp4',
    tutorial_chart_usage_video: '/videos/otenti-chart-usage_fr.mp4',
    
    // URLs des miniatures d'utilisation
    tutorial_create_application_thumbnail: '/thumbnails/create-application_fr.jpg',
    tutorial_add_user_thumbnail: '/thumbnails/add-user_fr.jpg',
    tutorial_add_role_thumbnail: '/thumbnails/add-role_fr.jpg',
    tutorial_user_management_thumbnail: '/thumbnails/user-management_fr.jpg',
    tutorial_chart_usage_thumbnail: '/thumbnails/chart-usage_fr.jpg',
    // Notifications lis

    notification_email_list: "Liste des emails de notification",
    // close: "Fermer",
    enter_email_address: "Entrez l'adresse email",
    loading_emails: "Chargement des emails...",
    no_emails_added: "Aucun email ajouté pour le moment",
    email_required: "L'adresse email est requise",
    invalid_email_format: "Format d'email invalide",
    email_already_exists: "Cet email existe déjà",
    email_added_successfully: "Email ajouté avec succès !",
    failed_to_add_email: "Échec de l'ajout de l'email. Veuillez réessayer.",
    email_updated_successfully: "Email mis à jour avec succès !",
    failed_to_update_email: "Échec de la mise à jour de l'email. Veuillez réessayer.",
    email_removed_successfully: "Email supprimé avec succès !",
    failed_to_remove_email: "Échec de la suppression de l'email. Veuillez réessayer.",
    failed_to_load_emails: "Échec du chargement des emails. Veuillez réessayer.",
    edit_email: "Modifier l'email",
    save_email: "Enregistrer l'email",
    remove_email: "Supprimer l'email",
    // adminilist
    administrators: "Administrateurs",
    manage_administrators: "Gérer les administrateurs",
    view_administrators: "Consulter les administrateurs",
    super_admin: "Super Admin",
    full_privileges: "Privilèges complets",
    delete_administrator: "Supprimer l'administrateur",
    action_reserved_for_super_admins: "Action réservée aux super administrateurs",
    loading_administrators: "Chargement des administrateurs...",
    no_administrators_found: "Aucun administrateur trouvé pour cette entreprise",
    select_company_to_view_admins: "Veuillez sélectionner une entreprise pour voir ses administrateurs",
    admin_count: "Nombre d'admin : {count}/3",
    error_loading_administrators: "Erreur lors du chargement des administrateurs",
    administrator_deleted_successfully: "Administrateur supprimé avec succès",
    error_deleting_administrator: "Erreur lors de la suppression de l'administrateur",
    // Page des Administrateurs
    company_id_missing: "Identifiant de l'entreprise manquant",
    only_super_admin_can_delete: "Seul un super administrateur peut supprimer des administrateurs",
    cannot_delete_own_account: "Vous ne pouvez pas supprimer votre propre compte",
    confirm_delete_admin: "Êtes-vous sûr de vouloir supprimer l'administrateur {name} ?",
    loading_user: "Chargement de l'utilisateur...",
    error_loading_user: "Erreur lors du chargement de l'utilisateur. Veuillez réessayer.",
    admin_management: "Gestion des administrateurs",
    create_admin: "Créer un administrateur",
    only_super_admins_can_create: "Seuls les super administrateurs peuvent créer des administrateurs",
    admin_created_successfully: "Administrateur créé avec succès ! 🎉",
    // Ajouter un administrateur
    // add_administrator: "Ajouter un administrateur",
    // close_modal: "Fermer la modale",
    // full_name: "Nom complet",
    // email: "Email",
    enter_full_name: "Entrez le nom complet",
    // enter_email_address: "Entrez l'adresse email",
    full_name_required: "Le nom complet est requis",
    // email_required: "L'email est requis",
    // invalid_email_format: "Format d'email invalide",
    failed_to_create_admin: "Échec de la création de l'administrateur",
    // cancel: "Annuler",
    creating: "Création en cours...",
    add_administrator_button: "Ajouter un administrateur",

    // Details des tickets 
    ticket_details: "Détails du Ticket",
                        refresh_data: "Rafraîchir les données",
                        data_refreshed: "Données rafraîchies",
                        error_loading_ticket: "Erreur de chargement du ticket",
                        error_loading_ticket_message: "Impossible de charger les détails du ticket. Veuillez réessayer plus tard.",
                        back_to_tickets: "Retour aux tickets",
                        loading_ticket: "Chargement du ticket",
                        please_wait: "Veuillez patienter...",
                        ticket_content: "Contenu du ticket",
                        discussion: "Discussion",
                        no_comments_yet: "Aucun commentaire pour le moment",
                        write_your_message: "Écrivez votre message",
                        support_team: "Équipe de support",
                        // pdf_document: "Document PDF",
                        // view: "Voir",
                        // download: "Télécharger",
                        // status_open: "Ouvert",
                        // status_resolved: "Résolu",
                        last_updated: "Dernière mise à jour",
                        // priority_high: "Haute",
                        // priority_medium: "Moyenne",
                        // priority_low: "Basse",
                        // category_technical: "Technique",
                        // category_billing: "Facturation",
                        // category_feature: "Fonctionnalité",
                        // category_other: "Autre",
                        created_by: "Créé par",
                        company_id: "ID de l'entreprise",
                        // close: "Fermer",
                        ticket_closed_success: "Ticket fermé avec succès",
                        ticket_closed_success_message: "Le ticket a été fermé avec succès.",
                        ticket_reopened: "Ticket rouvert",
                        ticket_reopened_message: "Le ticket a été rouvert avec succès.",
                        ticket_status_update_failed: "Échec de la mise à jour du statut",
                        ticket_status_update_failed_message: "Impossible de mettre à jour le statut du ticket. Veuillez réessayer.",
                        comment_submission_failed: "Échec de l'envoi du commentaire",
                        comment_submission_failed_message: "Impossible d'envoyer le commentaire. Veuillez réessayer.",
                        // close_ticket: "Fermer le ticket",
                        reopen_ticket: "Rouvrir le ticket",
                        updating_status: "Mise à jour du statut",
                        ticket_closed_message: "Ce ticket est fermé. Vous pouvez le rouvrir si nécessaire.",
  
                        companyName: "{companyName}",
                        applicationName: "{applicationName} Tableau de bord",
                        // loading: "Chargement...",
                        user: "Utilisateur",
                        confirmLogout: "Confirmer la déconnexion",
                        logoutQuestion: "Voulez-vous vraiment vous déconnecter ?",
                        // cancel: "Annuler",
                        // logout: "Déconnexion",
                        // dashboard: "Tableau de bord",  
                        
               admin_email_exists: "Cet email existe déjà",
  
  
    
  





































































  },









  //Versio, en Espagnol
  ES: {
    app_name: "Otenti",
    about: "Acerca de",
    sales: "Páginas de ventas",
    articles: "Artículos",
    support: "Soporte",
    contact: "Contacto",
    search: "Buscar",
    home: "Inicio",
    products: "Productos",
    become_client: "Hacerse Cliente",
    contact_us: "Contáctenos",
    authentication: "Autenticación",
    app_development: "Desarrollo de Aplicaciones",
    security_consulting: "Consultoría de Seguridad",
    user_training: "Capacitación de Usuarios",
    maintenance: "Mantenimiento",
    quick_links: "Enlaces Rápidos",
    our_services: "Nuestros Servicios",
    location: "Ciudad, País",
    footer_description: "Su socio confiable para soluciones innovadoras y seguras.",
    all_rights_reserved: "Todos los derechos reservados",
    
    // Navbar and Footer translations (already existing)
    welcome: "Bienvenido",
    welcome_back: "Estamos encantados de verte de nuevo. Accede a todas tus funciones de autenticación.",
    features_title: "Características",
    features_subtitle: "Todo lo que necesitas para la autenticación",
    cta_title: "¿Listo para empezar?",
    cta_button: "Empezar",
    auth: "Autenticación Segura",
    auth_desc: "Autenticación multifactor y protocolos de seguridad avanzados para proteger a tus usuarios.",
    users: "Gestión de Usuarios",
    users_desc: "Herramientas completas para gestionar roles y permisos de usuarios.",
    security: "Seguridad Empresarial",
    security_desc: "Funciones de seguridad de nivel empresarial y estándares de cumplimiento.",
    logout_title: "Confirmación de cierre de sesión",
    logout_message: "¿Estás seguro de que quieres cerrar tu sesión?",
    cancel: "Cancelar",
    confirm: "Cerrar sesión",
    success_title: "Desconexión exitosa",
    success_message: "Has sido desconectado con éxito.",
    admin_dashboard: "Panel de administración",
    sign_in: "Iniciar sesión",
    logout: "Cerrar sesión",
    
    // Hero Component
    title_part1: "Autenticación Segura",
    title_part2: "para Empresas Modernas",
    description: "Otenti proporciona servicios de autenticación de nivel empresarial que te ayudan a proteger tus aplicaciones y gestionar el acceso de usuarios de manera efectiva.",
    button: "Empezar",
    video_title: "Demo de Otenti",
    video_description: "Mira lo fácil que es integrar nuestro sistema de autenticación seguro en tu aplicación.",
    video_error: "Tu navegador no puede leer este video",
    

  // Home Component
  go_to_dashboard: "Ir al panel de control",
  welcome_to_secure_authenticator: "Bienvenido a un autenticador más seguro",
  authentication_authorization: "Autenticación y Autorización",
  safely_use_otenti: "Usa Otenti de forma segura como proveedor de identidad",
  define_access_level: "Definir el nivel de acceso a tu aplicación",
  identify_inactive_users: "Identificar fácilmente a usuarios inactivos",
  identify_abused_authentications: "Identificar fácilmente autenticaciones abusivas",
  learn_more: "Saber más",
  optimize_costs_mitigate_losses: "Optimizar costos y mitigar pérdidas",
  one_password_for_all: "Puedes usar de forma segura una sola contraseña para todo el software al que necesitas acceder",
  rely_on_identity_provider: "Confía en un proveedor de identidad completamente construido y mantenido para ti",
  password_cannot_be_stolen: "Tu contraseña no puede ser robada",
  digital_in_dna: "Digital en el ADN",
  digital_in_dna_description: "Somos una start-up innovadora con los desafíos de la ciberseguridad en el corazón de nuestro ADN. Hoy, ofrecemos un panel de servicios a cualquier cliente para ayudarles a mejorar la seguridad de sus datos, haciéndolos así más conformes con las regulaciones de seguridad nacionales/internacionales como ISO, NIS, NIS2, ISAE, etc.",
  read_our_articles: "Lee nuestros artículos",
  request_a_demo: "Solicitar una demo",
  cybersecurity_excellence: "Excelencia en Ciberseguridad",
  cybersecurity_excellence_description: "Nuestra experiencia ayuda a las empresas a proteger sus activos digitales más valiosos y a mantener el cumplimiento con los estándares de seguridad en evolución.",
  our_trusted_partners: "Nuestros socios de confianza",

  // / PartnersSlider Component
  they_trust_us: "Ellos confían en nosotros",
  trust: "confianza",
  join_our_trusted_network: "Únete a nuestra red de socios de confianza",
  become_a_partner: "Convertirse en socio",


  // EntrepriseDashboard Component
  applications_management: "Gestión de aplicaciones",
  new_application: "Nueva aplicación",
  add_administrator: "Añadir administrador",
  total_applications: "Total de aplicaciones",
  total_users: "Total de usuarios",
  average_users_per_app: "Promedio de usuarios por aplicación",
  applications: "Aplicaciones",
  user_distribution_by_application: "Distribución de usuarios por aplicación",
  export_csv: "Exportar a CSV",
  add_new_application: "Añadir nueva aplicación",
  application_created_successfully: "¡Aplicación creada con éxito!",
  failed_to_create_application: "No se pudo crear la aplicación. Por favor, intenta de nuevo.",
  administrator_added_successfully: "¡Administrador añadido con éxito!",
  no_data_to_export: "No hay datos disponibles para exportar",
  data_exported_successfully: "Datos exportados con éxito",
  application_name: "Nombre de la aplicación",
  user_count: "Número de usuarios",


  // DashboardApp Component
  dashboard: "Panel de control",
  error_company_id_not_found: "Error: No se encontró el ID de la empresa.",
  error_loading_data: "Error al cargar los datos.",
  user_activity_overview: "Resumen de la actividad de los usuarios",
  additional_insights: "Perspectivas adicionales",
  blocked_accounts: "Cuentas bloqueadas",
  connection_failures: "Fallos de conexión",
  new_users: "Nuevos usuarios",



  // Users Component
  missing_company_or_app_id: "Falta el ID de la empresa o de la aplicación",
  user_deleted_successfully: "Usuario eliminado con éxito",
  error_deleting_user: "Error durante la eliminación",
  user_locked_successfully: "Usuario bloqueado con éxito",
  error_locking_user: "Error durante el bloqueo",
  user_unlocked_successfully: "Usuario desbloqueado con éxito",
  error_unlocking_user: "Error durante el desbloqueo",



  // Contact Component
  contact_us2: "Contáctanos",
  name: "Nombre",
  email: "Correo electrónico",
  message: "Mensaje",
  send: "Enviar",
  sending: "Enviando...",
  message_sent_successfully: "¡Tu mensaje ha sido enviado con éxito!",
  failed_to_send_message: "No se pudo enviar el mensaje. Por favor, intenta de nuevo más tarde.",
  our_information: "Nuestra información",
  address: "123 Avenida Beige, Ciudad",
  phone: "(123) 456-7890",
  email_contact: "hola@ejemplo.com",

  // About Component
  about_otenti: "Acerca de Otenti",
  otenti_description: "Otenti es un líder innovador en ciberseguridad, especializado en soluciones de autenticación de próxima generación. Nuestra visión es hacer que la seguridad digital sea accesible e inquebrantable.",
  // our_services: "Nuestros servicios", // traduction exsistante 
  leadership_quote: "La transformación digital abre nuevas oportunidades de negocio al tiempo que introduce nuevos riesgos. Nuestra misión es ayudar a las organizaciones a navegar por esta transformación mientras garantizamos su seguridad digital.",
  ceo: "Director Ejecutivo",
  ceo_bio: "xxx xxx lidera la transformación digital y la estrategia de seguridad de Otenti, con más de 15 años de experiencia en ciberseguridad.",
  cto: "Director Técnico",
  cto_bio: "David supervisa el desarrollo tecnológico de Otenti, especializado en autenticación avanzada y criptografía.",
  cmo: "Director de Marketing",
  cmo_bio: "Marie lidera la estrategia de marketing global de Otenti, con una experiencia particular en marketing B2B de ciberseguridad.",
  our_leadership_team: "Nuestro equipo de liderazgo",
  leadership_team_description: "Conoce a los expertos detrás de las soluciones de seguridad innovadoras de Otenti",
  read_bio: "Leer biografía",
  free_demo: "Demostración gratuita",
  free_demo_description: "Descubre nuestras soluciones en acción con una demostración personalizada",
  blog: "Blog",
  blog_description: "Obtén las últimas perspectivas sobre seguridad digital",
  connect_with_otenti: "Conecta con Otenti",
  connect_description: "Descubre cómo nuestras soluciones pueden ayudar a asegurar tu transformación digital",
  connect_on_linkedin: "Conectar en LinkedIn",
  biography: "Biografía",

  // Sales Component
  our_solutions: "Nuestras soluciones",
  solutions_description: "Elige el plan perfecto para las necesidades de tu negocio y escala con confianza",
  starter_plan: "Inicial",
  starter_price: "49 €/mes",
  multi_factor_authentication: "Autenticación multifactor",
  up_to_1000_users: "Hasta 1000 usuarios",
  email_support: "Soporte por correo electrónico",
  basic_api_integration: "Integración básica de API",
  professional_plan: "Profesional",
  professional_price: "199 €/mes",
  everything_from_starter: "Todo lo del Inicial +",
  up_to_10000_users: "Hasta 10,000 usuarios",
  support_24_7: "Soporte 24/7",
  sso_saml_integration: "Integración SSO y SAML",
  advanced_analytics: "Análisis avanzado",
  enterprise_plan: "Empresarial",
  enterprise_price: "Personalizado",
  everything_from_professional: "Todo lo del Profesional +",
  unlimited_users: "Usuarios ilimitados",
  dedicated_support: "Soporte dedicado",
  on_premises_deployment: "Despliegue en las instalaciones",
  full_customization: "Personalización completa",
  subscribe: "Suscribirse",
  payment_for: "Pago para {plan}",
  full_name: "Nombre completo",
  card_number: "Número de tarjeta",
  card_number_placeholder: "1234 5678 9012 3456",
  expiry_date: "Fecha de vencimiento",
  expiry_date_placeholder: "MM/AA",
  cvv: "CVV",
  cvv_placeholder: "123",
  pay: "Pagar {price}",
  processing: "Procesando...",
  payment_secure: "Tu información de pago es segura y está encriptada",
  payment_success: "¡Gracias! Tu suscripción a {plan} ha sido procesada con éxito.",
  payment_failed: "No se pudo procesar el pago. Por favor, intenta de nuevo más tarde.",
  our_applications: "Nuestras aplicaciones",
  crm_pro: "CRM Pro",
  crm_pro_description: "Una solución integral para la gestión de relaciones con clientes.",
  erp_suite: "Suite ERP",
  erp_suite_description: "Un software potente para la gestión de recursos y producción.",
  ecommerce_boost: "Impulso E-Commerce",
  ecommerce_boost_description: "Optimiza tu tienda en línea con herramientas avanzadas.",
  // learn_more: "Saber más",
  custom_solution_title: "¿Necesitas una solución personalizada?",
  custom_solution_description: "Nuestro equipo de expertos está listo para ayudarte a construir la solución perfecta adaptada a las necesidades específicas de tu negocio",
  contact_our_team: "Contactar con nuestro equipo",

  // Support Component
  support_center: "Centro de soporte de Otenti",
  support_center_description: "Obtén ayuda con nuestras soluciones y servicios de autenticación",
  view_full_faq: "Ver todas las preguntas frecuentes",
  start_live_chat: "Iniciar chat en vivo",
  support_status: "Estado del soporte: En línea",
  avg_response_time: "Tiempo de respuesta promedio: 2 horas",
  frequently_asked_questions: "Preguntas frecuentes",
  faq_mfa_question: "¿Cómo configurar la autenticación de dos factores?",
  faq_mfa_answer: "Para configurar la autenticación de dos factores, ve a Configuración de la cuenta > Seguridad > Autenticación de dos factores y sigue las instrucciones en pantalla para configurar tu método preferido.",
  faq_api_question: "¿Dónde encontrar la documentación de la API?",
  faq_api_answer: "Nuestra documentación completa de la API está disponible en el portal de desarrolladores. Inicia sesión en tu cuenta, ve a la sección de Desarrolladores y selecciona Documentación de la API.",
  faq_password_question: "¿Cómo restablezco mi contraseña?",
  faq_password_answer: "Para restablecer tu contraseña, haz clic en el enlace 'Olvidé mi contraseña' en la página de inicio de sesión. Recibirás un correo electrónico con instrucciones para crear una nueva contraseña.",
  support_tickets: "Tickets de soporte",
  create_ticket: "Crear un ticket",
  my_tickets: "Mis tickets",
  create_new_ticket: "Crear un nuevo ticket de soporte",
  tips_for_resolution: "Consejos para una resolución rápida",
  tip_describe_problem: "Describe claramente tu problema con todos los detalles relevantes.",
  tip_include_screenshots: "Incluye capturas de pantalla o mensajes de error si aplica.",
  tip_list_steps: "Enumera los pasos que ya has tomado para resolver el problema.",
  subject: "Asunto",
  subject_placeholder: "Breve descripción de tu problema",
  detailed_description: "Descripción detallada",
  description_placeholder: "Por favor, proporciona tantos detalles como sea posible...",
  priority: "Prioridad",
  priority_low: "Baja",
  priority_medium: "Media",
  priority_high: "Alta",
  category: "Categoría",
  category_technical: "Problema técnico",
  category_billing: "Pregunta de facturación",
  category_feature: "Solicitud de funcionalidad",
  category_other: "Otro",
  submit_ticket: "Enviar ticket de soporte",
  ticket_submitted_success: "¡Ticket enviado con éxito!",
  all_tickets: "Todos los tickets",
  open_tickets: "Abiertos",
  resolved_tickets: "Resueltos",
  no_tickets_found: "No se encontraron tickets",
  no_tickets_message: "No hay tickets que coincidan con tus criterios de filtrado actuales.",
  status_open: "Abierto",
  status_resolved: "Resuelto",
  ticket_number: "Ticket #{id}",
  created_on: "Creado el {date}",
  update_ticket: "Actualizar",
  close_ticket: "Cerrar",
  support_response: "Respuesta del soporte",
  pdf_document: "Documento PDF • 2,4 MB",
  view: "Ver",
  download: "Descargar",
  response_helpful: "¿Fue útil esta respuesta?",
  click_to_rate: "Haz clic para calificar",
  contact_us_directly: "Contáctanos directamente",
  phone_support: "Soporte telefónico",
  // email_support: "Soporte por correo electrónico",  // traduction existante
  start_live_chat_now: "Iniciar chat en vivo ahora",
  support_hours: "Horario de soporte",
  monday_friday: "Lunes - Viernes",
  monday_friday_hours: "9:00 - 18:00",
  saturday: "Sábado",
  saturday_hours: "10:00 - 16:00",
  sunday: "Domingo",
  sunday_hours: "Cerrado",
  emergency_support: "Soporte de emergencia",
  emergency_support_description: "Para problemas críticos fuera del horario laboral, los clientes premium pueden acceder a nuestro soporte de emergencia 24/7.",
  learn_premium_support: "Conoce más sobre el soporte premium",
  ticket_mfa_subject: "Problema de configuración de MFA",
  ticket_mfa_description: "No puedo configurar la autenticación de dos factores...",
  ticket_mfa_response: "Aquí están los pasos para resolver tu problema de configuración de MFA...",
  ticket_api_subject: "Documentación de API",
  ticket_api_description: "Solicitud de documentación detallada para la integración de API",
  ticket_api_response_content: "Documentación_API_Otenti.pdf",

  // Articles Component
  articles_and_news: "Artículos y Noticias",
  read_article: "Leer artículo",
  back_to_articles: "Volver a los artículos",
  close_article: "Cerrar artículo",
  close_article_aria: "Cerrar artículo",
  article_mfa_title: "La importancia de la autenticación multifactor en 2025",
  article_mfa_description: "Descubre cómo la autenticación multifactor se ha vuelto indispensable para la seguridad de las empresas modernas.",
  article_mfa_date: "21 de enero de 2025",
  article_mfa_content: `
    # La importancia de la autenticación multifactor en 2025

    En un mundo cada vez más conectado, la seguridad de los datos se ha convertido en una preocupación importante para las empresas. La autenticación multifactor (MFA) se ha consolidado como una solución esencial para proteger los accesos sensibles.

    ## ¿Por qué es crucial la MFA?

    Los ciberataques son cada vez más sofisticados. Una simple contraseña ya no es suficiente para garantizar la seguridad de tus datos. En 2024, más del 80 % de las violaciones de datos involucraron credenciales comprometidas.

    La autenticación multifactor añade capas adicionales de seguridad al combinar:
    - Algo que sabes (contraseña)
    - Algo que tienes (teléfono inteligente, token)
    - Algo que eres (huella dactilar, reconocimiento facial)

    ## Beneficios concretos para tu empresa

    - Reducción del 99,9 % de los riesgos de compromiso de cuentas, según estudios recientes
    - Cumplimiento de regulaciones como GDPR, PCI DSS y otras
    - Mejora de la confianza de los clientes y socios
    - Protección contra el phishing y los ataques de fuerza bruta

    ## Cómo implementar la MFA de manera efectiva

    La implementación de una solución MFA debe ser cuidadosamente planificada para no afectar la experiencia del usuario. Nuestros expertos recomiendan un enfoque gradual con una solución flexible que se adapte a diferentes contextos de uso.

    Contáctanos para descubrir cómo nuestra solución puede proteger tu empresa mientras mantiene una experiencia de usuario fluida.
  `,
  article_tsuriel_title: "Proteger tus datos con Tsuriel Authentication",
  article_tsuriel_description: "Un análisis profundo de las funciones de seguridad avanzadas de nuestra solución de autenticación.",
  article_tsuriel_date: "18 de enero de 2025",
  article_tsuriel_content: `
    # Proteger tus datos con Tsuriel Authentication

    Nuestra solución Tsuriel Authentication representa el estado del arte en seguridad de autenticación. Aquí hay un análisis detallado de las funciones que la distinguen.

    ## Arquitectura de seguridad avanzada

    Tsuriel Authentication utiliza una arquitectura de confianza cero con cifrado de extremo a extremo. Todos los datos están cifrados en tránsito y en reposo con los algoritmos más recientes reconocidos por la industria.

    ## Funciones clave

    1. **Autenticación contextual**
       Nuestro sistema evalúa en tiempo real el nivel de riesgo de cada intento de inicio de sesión analizando múltiples factores: ubicación, dispositivo, comportamiento del usuario, etc.

    2. **Biometría de nueva generación**
       Más allá de las huellas dactilares, nuestra solución integra reconocimiento facial 3D, reconocimiento de voz e incluso análisis de comportamiento.

    3. **Gestión centralizada de políticas**
       Una consola de administración intuitiva permite definir políticas de acceso granulares adaptadas a diferentes grupos de usuarios.

    ## Estudios de caso

    Nuestros clientes han observado:
    - Reducción del 95 % en los incidentes de seguridad relacionados con la autenticación
    - Disminución del 60 % en las llamadas al soporte para restablecimiento de contraseñas
    - Aumento del 25 % en la satisfacción del usuario gracias a procesos de inicio de sesión más fluidos

    Descubre cómo Tsuriel Authentication puede transformar tu estrategia de seguridad programando una reunión con uno de nuestros expertos.
  `,
  article_ux_security_title: "Cómo mejorar la experiencia del usuario mientras se refuerza la seguridad",
  article_ux_security_description: "Las mejores prácticas para mantener un equilibrio entre seguridad y facilidad de uso.",
  article_ux_security_date: "15 de enero de 2025",
  article_ux_security_content: `
    # Cómo mejorar la experiencia del usuario mientras se refuerza la seguridad

    El equilibrio entre una seguridad robusta y una experiencia de usuario fluida a menudo se percibe como un desafío insuperable. Sin embargo, los enfoques modernos demuestran que es posible lograr ambos objetivos simultáneamente.

    ## El falso dilema de la seguridad vs. la experiencia

    Históricamente, más seguridad significaba más fricción para el usuario. Hoy en día, las tecnologías inteligentes permiten ajustar dinámicamente los niveles de seguridad según el contexto, reduciendo la fricción en escenarios de bajo riesgo.

    ## Estrategias efectivas

    ### 1. Autenticación progresiva
    Comienza con un método simple y añade factores solo cuando el contexto lo requiera (operación sensible, comportamiento inusual).

    ### 2. Biometría transparente
    Las tecnologías biométricas modernas pueden operar en segundo plano sin intervención activa del usuario.

    ### 3. Inicio de sesión único (SSO) seguro
    Permite a los usuarios acceder a múltiples aplicaciones con una sola autenticación fuerte, en lugar de memorizar múltiples credenciales.

    ## Resultados concretos

    Las empresas que han adoptado estos enfoques han observado:
    - Aumento del 35 % en la adopción de soluciones por parte de los usuarios
    - Reducción del 40 % en los intentos de eludir la seguridad por parte de los empleados
    - Mejor percepción de las políticas de seguridad dentro de la organización

    Nuestro equipo puede guiarte en la implementación de estas estrategias para transformar la seguridad de un obstáculo percibido en una ventaja competitiva.
  `,
    // SearchPage Component
    advanced_search: "Búsqueda avanzada",
    search_placeholder: "Buscar...",
    search_button: "Buscar",
    loading: "Cargando...",
    no_results_found: "No se encontraron resultados para \"{query}\"",
    category_all: "Todos",
    category_Application: "Aplicación",
    category_users: "Usuarios",
    category_Articles: "Artículos",
    category_documents: "Documentos",
    search_result_tech_company_title: "Compañía tecnológica",
    search_result_tech_company_description: "Soluciones tecnológicas empresariales",
    search_result_ibro_title: "Ibro",
    search_result_ibro_description: "Ingeniero de software en Compañía tecnológica",
    search_result_project_proposal_title: "Propuesta de proyecto",
    search_result_project_proposal_description: "Documentación técnica para un nuevo proyecto",

  
    // BecomeClient Component
    become_client_title: "Hacerse cliente",
    become_client_description: "Complete la siguiente información para enviar su solicitud",
    watch_demonstration: "Ver demostración",
    demo_modal_title: "¿Necesita ayuda con el registro?",
    demo_modal_description: "¿Le gustaría ver un video de demostración que explica cómo completar su solicitud de registro?",
    demo_modal_skip: "No, gracias",
    demo_modal_watch: "Ver demo",
    demo_video_title: "Cómo hacerse cliente",
    demo_video_description: "Este video le guía a través del proceso de registro de clientes.",
    start_registration: "Iniciar registro",
    step_information: "Información",
    step_plan: "Plan",
    step_confirmation: "Confirmación",
    company_information: "Información de la empresa",
    choose_plan: "Elija su plan",
    request_sent_success: "¡Solicitud enviada con éxito!",
    request_review_message: "Nuestro equipo revisará su solicitud y se pondrá en contacto con usted en breve.",
    back_to_homepage: "Volver a la página de inicio",
    error_registering_company: "Error al registrar la empresa",



  // RolesPage Component
  roles_management: "Gestión de roles",
  add_role: "Agregar un rol",
  role_name: "Nombre del rol",
  actions: "Acciones",
  edit_role: "Editar rol",
  delete_role: "Eliminar rol",
  open_menu: "Abrir menú",
  add_new_role: "Agregar un nuevo rol",
  enter_role_name: "Ingrese el nombre del rol",
  edit_role_name: "Editar el nombre del rol",
  no_roles_available: "No hay roles disponibles",
  role_added_success: "Rol agregado con éxito",
  role_modified_success: "Rol modificado con éxito",
  role_deleted_success: "Rol eliminado con éxito",
  error_loading_roles: "Error al cargar los roles",
  error_adding_role: "Error al agregar el rol",
  error_modifying_role: "Error al modificar el rol",
  error_deleting_role: "Error al eliminar el rol",
  unexpected_response_format: "Formato de respuesta inesperado",
  add: "Agregar",
  save: "Guardar",
  // cancel: "Cancelar", traducion existante

  // Sidebar Component
  menu: "Menú",
  nav_home: "Inicio",
  nav_applications: "Aplicaciones",
  nav_administrator: "Administrador",
  nav_settings: "Configuraciones",
  expand_sidebar: "Expandir barra lateral",
  collapse_sidebar: "Colapsar barra lateral",




  // SidebarApp Component
  app_secure_by_otenti: "Aplicación segura por Otenti",
  nav_dashboard: "Tablero",
  nav_users: "Usuarios",
  nav_roles: "Roles",
  nav_support: "Soporte",
  // nav_settings: "Configuraciones", // Déjà défini dans Sidebar.tsx
  // expand_sidebar: "Expandir barra lateral", // Déjà défini dans Sidebar.tsx
  // collapse_sidebar: "Colapsar barra lateral", // Déjà défini dans Sidebar.tsx




  // UserList Component
  users_list: "Lista de usuarios",
  search_users: "Buscar usuarios...",
  add_users: "Agregar usuarios",
  loading_users: "Cargando usuarios...",
  error_loading_users: "Error al cargar usuarios",
  // email: "Correo electrónico",
  // full_name: "Nombre completo",
  status: "Estado",
  // actions: "Acciones",
  details: "Detalles",
  // add_role: "Agregar rol",
  edit: "Editar",
  lock: "Bloquear",
  unlock: "Desbloquear",
  delete: "Eliminar",
  view_details: "Ver detalles",
  status_active: "Activo",
  status_locked: "Bloqueado",
  add_role_to_user: "Agregar rol a {user}",
  select_role: "Seleccionar rol",
  select_role_placeholder: "Seleccionar un rol",
  please_select_role: "Por favor, selecciona un rol",
  // role_added_success: "Rol agregado con éxito",
  // error_loading_roles: "No se pudieron cargar los roles",
  error_loading_roles_log: "Error al cargar los roles",
  // error_adding_role: "No se pudo agregar el rol",
  error_adding_role_log: "Error al agregar el rol",
  // add: "Agregar", // Déjà défini dans RolesPage.tsx
  // cancel: "Cancelar", // Déjà défini dans RolesPage.tsx
  // roles: "Roles", // Déjà défini dans RolesPage.tsx

  // UserDetails Component
  user_details: "Detalles del usuario",
  last_activity: "Última actividad",
  last_login: "Último inicio de sesión",
  not_available: "N/D",
  close: "Cerrar",
  // delete_role: "Eliminar este rol", déja existant dans la traduction 
  error_deleting_role_log: "Error al eliminar el rol",
  // email: "Correo electrónico", // Déjà défini dans UserList.tsx
  // full_name: "Nombre completo", // Déjà défini dans UserList.tsx
  // status: "Estado", // Déjà défini dans UserList.tsx
  // roles: "Roles", // Déjà défini dans UserList.tsx
  // status_active: "Activo", // Déjà défini dans UserList.tsx
  // status_locked: "Bloqueado", // Déjà défini dans UserList.tsx
  // role_deleted_success: "Rol eliminado con éxito", // Déjà défini dans RolesPage.tsx
  // error_deleting_role: "No se pudo eliminar el rol", // Déjà défini dans RolesPage.tsx

 



  // UserFormModal Component
  new_user: "Nuevo usuario",
  edit_user: "Editar usuario",
  email_placeholder: "email@ejemplo.com",
  full_name_placeholder: "Nombre Apellido",
  update: "Actualizar",
  user_added_success: "Usuario agregado con éxito",
  user_updated_success: "Usuario actualizado con éxito",
  error_user_action: "Error durante {action} del usuario",
  adding: "la adición",
  updating: "la actualización",
  // email: "Correo electrónico", // Déjà défini dans UserList.tsx
  // full_name: "Nombre completo", // Déjà défini dans UserList.tsx
  // roles: "Roles", // Déjà défini dans UserList.tsx
  // add: "Agregar", // Déjà défini dans RolesPage.tsx
  // cancel: "Cancelar", // Déjà défini dans RolesPage.tsx
  // close: "Cerrar", // Déjà défini dans UserDetails.tsx
  // Dans Translation.ts, ajouter ces clés dans chaque section de langue (EN, FR, ES)




  // ApplicationFileUpload Component
  drag_drop_csv: "Arrastra y suelta un archivo CSV aquí, o haz clic para seleccionar",
  drop_csv: "Suelta el archivo CSV aquí...",
  scanning_file: "Escaneando el archivo por seguridad...",
  download_template: "Descargar plantilla",
  template_filename: "plantilla_roles_aplicación.csv",
  file_constraints: "Tamaño máximo: 1 MB • Solo se aceptan archivos CSV simples",
  error_no_file_selected: "Ningún archivo seleccionado",
  error_only_csv: "Solo se aceptan archivos CSV",
  error_invalid_file_type: "Tipo de archivo inválido",
  error_security_risk: "Archivo rechazado: se detectó un riesgo de seguridad potencial",
  error_invalid_csv_structure: "Estructura CSV inválida. Debe contener una columna 'Rol'",
  error_no_valid_roles: "No se encontraron roles válidos en el archivo CSV",
  error_parsing_csv: "Error al analizar el archivo CSV",
  error_invalid_csv: "Archivo CSV inválido",

  

  // UsersDistributionChart Component
  users_distribution: "Distribución de usuarios por aplicación",
  loading_user_data: "Cargando datos de usuarios...",
  no_user_data: "No hay datos de usuarios disponibles",
  showing_applications: "Mostrando {appCount} aplicaciones con {userCount} usuarios",
  application: "Aplicación",
  // users: "Usuarios", déja traduit
  percentage: "Porcentaje",
  users_count: "{count} usuarios",
  app_fallback: "App {id}",
  csv_downloaded: "¡CSV descargado!",
  pdf_downloaded: "¡PDF descargado!",
  users_distribution_filename_csv: "distribución_usuarios.csv",
  users_distribution_filename_pdf: "distribución_usuarios.pdf",
  chart_info: "Información del gráfico",
  // export_csv: "Exportar a CSV",deja traduit
  export_pdf: "Exportar a PDF",
  error_export_csv_log: "Error de exportación CSV",
  error_export_pdf_log: "Error de exportación PDF",


  // SettingApp Component
  settings: "Configuración",
  // loading: "Cargando...",
  error_loading: "Error al cargar los datos",
  // description: "Descripción",
  no_description: "Sin descripción",
  client_id: "ID de Cliente",
  // status: "Estado",
  // status_active: "Activo",
  status_inactive: "Inactivo", // Ajouté pour d'autres statuts possibles
  copy: "Copiar",
  copy_application_name: "Copiar el nombre de la aplicación",
  copy_client_id: "Copiar el ID de cliente",
  copy_redirect_uri: "Copiar la URI de redirección",
  // edit: "Editar",
  edit_status: "Editar estado",
  status_edit_alert: "La función de modificación de estado aún no está implementada",
  delete_app: "Eliminar aplicación",
  update_settings: "Actualizar configuración",
  confirm_deletion: "Confirmar eliminación",
  delete_confirmation: "¿Realmente quieres eliminar '{appName}'? Esta acción no se puede deshacer.",
  error_delete_app_log: "Error al eliminar la aplicación",
  error_update_app_log: "Error al actualizar la aplicación",
  edit_application: "Editar aplicación",
  // Réutilisées :
  // application_name: "Nombre de la aplicación", // Depuis ApplicationForm.tsx
  // redirect_uri: "URI de redirección", // Depuis ApplicationForm.tsx
  // cancel: "Cancelar", // Depuis UserFormModal.tsx, ApplicationForm.tsx
  // delete: "Eliminar", // Depuis UserList.tsx, UserDetails.tsx
  // save: "Guardar", // Depuis UserFormModal.tsx
 
  // AddRoleModal Component
  // add_new_role: "Agregar nuevo rol",
  // role_name: "Nombre del rol",
  // enter_role_name: "Introduce el nombre del rol",
  // add: "Agregar",
  // add_role: "Agregar rol",
  error_add_role_log: "Error al agregar el rol",
  // Réutilisée :
  // cancel: "Cancelar", // Depuis UserFormModal.tsx, ApplicationForm.tsx, SettingApp.tsx
  post_logout_redirect_uris: "URIs de redirección post-cierre de sesión",
copy_post_logout_redirect_uris: "Copiar las URIs de redirección post-cierre de sesión",
no_post_logout_redirect_uris: "No se han especificado URIs de redirección post-cierre de sesión",
active: "Activo",
blocked: "Bloqueado",
  


  // About Component - Général
  // close: "Cerrar",
  // learn_more: "Saber más",
  cybersecurity: "Ciberseguridad",
  view_bio: "Ver la biografía de {name}",

  // About Component - Notre Mission
  mission_description_new: "Ofrecerte soluciones a la altura de tus necesidades, innovadoras, fiables, sofisticadas y de alta calidad.",
  mission_commitment_title: "Nuestro Compromiso",
  mission_commitment_description: "Como uno de los productos de Tsuriel Cyber y TI, Otenti se compromete a proporcionar servicios de ciberseguridad de primer nivel, abordando los desafíos digitales actuales y futuros.",
  mission_approach_title: "Nuestro Enfoque",
  mission_approach_description: "Cada solución está diseñada a medida, teniendo en cuenta tus requisitos específicos y objetivos comerciales, garantizando una protección óptima y una experiencia de usuario impecable.",

  // About Component - Nos Valeurs
  our_values: "Nuestros Valores",
  values_description: "Un servicio centrado en el cliente basado en la confianza y la confidencialidad, la transparencia, la eficiencia y el sentido de la responsabilidad.",
  value_customer_service_title: "Servicio Centrado en el Cliente",
  value_customer_service_description: "Un servicio enfocado en el cliente, atento a tus necesidades específicas.",
  value_confidentiality_title: "Confidencialidad",
  value_confidentiality_description: "Protección rigurosa de tus datos e información sensible.",
  value_transparency_title: "Transparencia",
  value_transparency_description: "Comunicación clara y honesta durante toda nuestra colaboración.",
  value_trust_title: "Confianza",
  value_trust_description: "Relaciones basadas en la fiabilidad e integridad profesional.",
  value_responsibility_title: "Responsabilidad",
  value_responsibility_description: "Un compromiso total con la calidad y la seguridad de nuestras soluciones.",

  // About Component - Nos Services
  services_description: "Otenti, uno de los productos de Tsuriel Cyber y TI, ofrece servicios en Ciberseguridad, Arquitectura, Seguridad de Datos, Digitalización, Auditoría, Diseño y Mejora de Sistemas.",
  service_cybersecurity_title: "Ciberseguridad",
  service_cybersecurity_description: "Protección avanzada contra amenazas digitales y securización de tus sistemas.",
  service_it_architecture_title: "Arquitectura TI",
  service_it_architecture_description: "Diseño e implementación de infraestructuras informáticas robustas y escalables.",
  service_data_security_title: "Seguridad de Datos",
  service_data_security_description: "Soluciones especializadas para la protección y gestión segura de tus datos.",
  service_digitalization_title: "Digitalización",
  service_digitalization_description: "Transformación digital adaptada a tus necesidades específicas y sector de actividad.",
  service_audit_title: "Auditoría",
  service_audit_description: "Evaluación exhaustiva de tus sistemas para identificar vulnerabilidades y oportunidades de mejora.",
  service_design_title: "Diseño",
  service_design_description: "Creación de interfaces intuitivas y ergonómicas para una experiencia de usuario óptima.",
  service_system_improvement_title: "Mejora de Sistemas",
  service_system_improvement_description: "Optimización de tus infraestructuras existentes para un mejor rendimiento y seguridad.",
  discover_all_services: "Descubre todos nuestros servicios",

  // About Component - Contact CTA
  secure_digital_title: "¿Listo para asegurar tu entorno digital?",
  secure_digital_description: "Contáctanos hoy para una consulta personalizada y descubre cómo Otenti puede transformar tu enfoque de la ciberseguridad.",
  request_demo: "Solicitar una demo",

  // Clés existantes (exemples, à vérifier dans votre Translations.ts)
  // about_otenti: "Acerca de Otenti",
  // otenti_description: "...",
  // our_mission: "Nuestra Misión",
  // mission_description: "...",
  // our_services: "Nuestros Servicios",
  // contact_us: "Contáctanos",
  // core_value_security_title: "...",
  // core_value_security_description: "...",
  // core_value_trust_title: "...",
  // core_value_trust_description: "...",
  // core_value_innovation_title: "...",
  // core_value_innovation_description: "...",
  // learn_about_our_values: "Conoce más sobre nuestros valores",
  // leadership_quote: "...",
  // ceo: "CEO",
  // ceo_bio: "...",
  // cto: "Director Técnico",
  // cto_bio: "...",
  // cmo: "Director de Marketing",
  // cmo_bio: "...",
  // our_history: "Nuestra Historia",
  // history_description: "...",
  // history_2020_title: "...",
  // history_2020_description: "...",
  // history_2022_title: "...",
  // history_2022_description: "...",
  // history_2024_title: "...",
  // history_2024_description: "...",
  // our_leadership_team: "Nuestro Equipo de Liderazgo",
  // leadership_team_description: "...",
  // read_bio: "Leer biografía",
  // connect_on_linkedin: "Conectar en LinkedIn",
  // biography: "Biografía",
  // connect_with_otenti: "Conecta con Otenti",
  // connect_description: "...",
  // free_demo: "Demo gratuita",
  // free_demo_description: "...",
  // contact_us: "Contáctanos",
  // contact_us_description: "...",
  // blog: "Blog",
  // blog_description: "...",
  // expertise_title: "...",
  // expertise_description: "...",
  // expertise_item_1: "...",
  // expertise_item_2: "...",
  // expertise_item_3: "...",
  // view_our_services: "Ver nuestros servicios",
  // contact_our_team: "Contactar con nuestro equipo",
  // security_excellence_title: "...",
  // security_excellence_description: "...",


 




  // LandingPage - Général
  // percentage: "%",
  no_data_available: "No hay datos disponibles para el período seleccionado",
  failed_to_load_data: "No se pudieron cargar los datos de las aplicaciones. Por favor, intenta de nuevo más tarde.",
  // view_details: "Ver detalles para {title}",

  // Périodes
  period: "Período",
  select_period: "Seleccionar un período",
  select_option: "Seleccionar {label}",
  months: " 3 meses",
  monthss: "6 meses",
  // 6_months: "6 meses",
   year: "año",
  all_time: "Todo el tiempo",

  // Menu
  // menu: "Menú",
  dashboard_company: "Tablero de la empresa",
  generate_new_key: "Generar nueva clave",
  request_registration: "Solicitar registro",
  edit_notification_list: "Editar lista de notificaciones",
  // settings: "Configuraciones",

  // Export
  global_export: "Exportación global",
  global_export_description: "Exportar estadísticas completas de la empresa, incluyendo todas las aplicaciones y datos de usuarios.",
  export_full_report: "Exportar informe completo (CSV)",
  preparing_data: "Preparando datos...",
  no_data_for_export: "No hay datos disponibles para exportar en el período seleccionado.",
  company_stats_report: "informe-estadísticas-empresa",
  // application: "Aplicación",
  authentication_rate: "Tasa de autenticación",
  failed_logins: "Inicios de sesión fallidos",
  locked_accounts: "Cuentas bloqueadas",
  inactive_users: "Usuarios inactivos",

  // CompanyStatsChart
  statistics_over: "Estadísticas sobre {period}",
  authentication_rate_by_app: "Tasa de autenticación por aplicación",
  login_failures_by_app: "Fallos de inicio de sesión por aplicación",
  locked_accounts_by_app: "Cuentas bloqueadas por aplicación",
  user_inactivity_by_app: "Inactividad de usuarios por aplicación",
  low_authentication_warning: "Algunas aplicaciones tienen tasas de autenticación bajas",
  high_failure_warning: "Algunas aplicaciones tienen tasas de fallo altas",
  high_lock_warning: "Algunas aplicaciones tienen tasas de bloqueo altas",
  high_inactivity_warning: "Algunas aplicaciones tienen tasas de inactividad altas",

  // StatSummaryCard
  from_previous_period: "respecto al período anterior",

  // AnalyticsHub
  analytics_hub: "Centro de análisis",
  analytics_hub_description: "Tablero interactivo para monitorear el rendimiento de seguridad de las aplicaciones",
  overview: "Resumen",
  security_status: "Estado de seguridad",
  user_activity: "Actividad de usuarios",

  // AnalyticsHub - Overview
  apps_performance_summary: "Resumen de rendimiento de aplicaciones",
  quick_insights: "Perspectivas rápidas",
  low_authentication_insight: "Las tasas de autenticación están por debajo del objetivo. Considera entrenar a los usuarios o simplificar los flujos de autenticación.",
  high_failure_insight: "Se detectaron tasas de fallo altas. Verifica posibles problemas de seguridad o problemas de interfaz de usuario.",
  high_lockout_insight: "Bloqueos de cuentas elevados indican posibles intentos de fuerza bruta o problemas de contraseñas de usuarios.",
  high_inactivity_insight: "Tasas de inactividad de usuarios altas. Considera campañas de compromiso o limpieza de cuentas.",
  healthy_metrics_insight: "Todas las métricas de las aplicaciones están en rangos saludables. Continúa monitoreando para una seguridad óptima.",
  recommended_actions: "Acciones recomendadas",
  view_all_recommendations: "Ver todas las recomendaciones",
  manage_users: "Gestionar usuarios",
  manage_users_description: "Configurar controles de acceso y permisos de usuarios",
  security_settings: "Configuraciones de seguridad",
  security_settings_description: "Revisar y actualizar políticas de seguridad",
  notifications: "Notificaciones",
  notifications_description: "Configurar alertas de seguridad y actividad",

  // AnalyticsHub - Security Status
  security_status_overview: "Resumen del estado de seguridad",
  auth_status_distribution: "Distribución del estado de autenticación",
  security_risk_assessment: "Evaluación de riesgos de seguridad",
  authentication_health: "Salud de autenticación",
  login_failures: "Fallos de inicio de sesión",
  account_lockouts: "Bloqueos de cuenta",
  // user_activity: "Actividad de usuarios",
  review_security_settings: "Revisar configuraciones de seguridad",
  authenticated: "Autenticado",
  locked: "Bloqueado",
  inactive: "Inactivo",

  // AnalyticsHub - User Activity
  user_activity_metrics: "Métricas de actividad de usuarios",
  active_vs_inactive_users: "Usuarios activos vs inactivos por aplicación",
  active_users: "Usuarios activos %",
  user_engagement_summary: "Resumen de compromiso de usuarios",
  user_engagement_description: "Las aplicaciones muestran un promedio de {active}% de usuarios activos frente a {inactive}% de usuarios inactivos.",
  security_event_summary: "Resumen de eventos de seguridad",
  security_event_description: "Las aplicaciones muestran un promedio de {failed}% de fallos de inicio de sesión y {locked}% de cuentas bloqueadas.",
  configure_alerts: "Configurar alertas",
  


  // FailedLoginsChart
  // percentage: "%",
  // loading: "Cargando...",
  // error_loading: "Error al cargar los datos",
  download_error: "Ocurrió un error al descargar",
  login_failure_statistics: "Estadísticas de fallos de inicio de sesión",
  // select_period: "Seleccionar un período",
  // select_option: "Seleccionar {label}",
  hours24: "24 horas",
  days7: "7 días",
  // days30: "30 días",
   days90: "90 días",
  // download: "Descargar",
  png: "PNG",
  download_png: "Descargar como PNG",
  jpeg: "JPEG",
  download_jpeg: "Descargar como JPEG",
  pdf: "PDF",
  download_pdf: "Descargar como PDF",
  failed_logins_period: "Fallos ({period})",
  successful_logins: "Inicios de sesión exitosos",
  failed_login_summary: "{percentage}% de los usuarios ({count}/{totalUsers}) experimentaron fallos de inicio de sesión en los últimos {period}.",
  // high_failure_warning: "Advertencia: Tasa de fallos inusualmente alta",
  login_failure_kpi: "KPI-fallo-inicio-sesión",


  // InactiveUsersChart
  // percentage: "%",
  // loading: "Cargando...",
  // error_loading: "Error al cargar los datos",
  // download_error: "Ocurrió un error al descargar",
  user_inactivity_status: "Estado de inactividad de usuarios",
  // select_period: "Seleccionar un período",
  // select_option: "Seleccionar {label}",
  days30: "30 días",
  days60: "60 días",
  // days90: "90 días",
  days180: "180 días",
  // download: "Descargar",
  // png: "PNG",
  // download_png: "Descargar como PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Descargar como JPEG",
  // pdf: "PDF",
  // download_pdf: "Descargar como PDF",
  inactive_users_period: "Inactivos ({period}+)",
  // active_users: "Usuarios activos",
  inactive_user_summary: "{percentage}% de los usuarios ({count}/{totalUsers}) han estado inactivos durante más de {period}.",
  recently_inactive_summary: "{count} usuarios se volvieron inactivos en este período.",
  // high_inactivity_warning: "Advertencia: Una alta tasa de inactividad puede indicar cuentas no utilizadas",
  inactive_users_kpi: "KPI-usuarios-inactivos",

  
  // LockedUsersChart
  // percentage: "%",
  // loading: "Cargando...",
  // error_loading: "Error al cargar los datos",
  // download_error: "Ocurrió un error al descargar",
  account_lock_status: "Estado de bloqueo de cuentas",
  // select_period: "Seleccionar un período",
  // select_option: "Seleccionar {label}",
  // hours24: "24 horas",
  // days7: "7 días",
  // days30: "30 días",
  // all_time: "Todo el tiempo",
  // download: "Descargar",
  // png: "PNG",
  // download_png: "Descargar como PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Descargar como JPEG",
  // pdf: "PDF",
  // download_pdf: "Descargar como PDF",
  locked_users: "Usuarios bloqueados",
  // active_users: "Usuarios activos",
  locked_user_summary: "{percentage}% de las cuentas ({count}/{totalUsers}) están actualmente bloqueadas.",
  recent_locks_summary: "{count} cuentas fueron bloqueadas en los últimos {period}.",
  // high_lock_warning: "Advertencia: Una alta tasa de bloqueo puede indicar problemas de seguridad",
  locked_users_kpi: "KPI-usuarios-bloqueados",

  
  // AuthPercentageChart
  // percentage: "%",
  // loading: "Cargando...",
  // error_loading: "Error al cargar los datos",
  // download_error: "Ocurrió un error al descargar",
  user_authentication_rate: "Tasa de autenticación de usuarios",
  // select_period: "Seleccionar un período",
  // select_option: "Seleccionar {label}",
  // days7: "7 días",
  // days30: "30 días",
  // days90: "90 días",
  // days180: "180 días",
  // download: "Descargar",
  // png: "PNG",
  // download_png: "Descargar como PNG",
  // jpeg: "JPEG",
  // download_jpeg: "Descargar como JPEG",
  // pdf: "PDF",
  // download_pdf: "Descargar como PDF",
  authenticated_users_period: "Autenticados ({period})",
  not_authenticated_users: "No autenticados",
  auth_summary: "{percentage}% de los usuarios se autenticaron en los últimos {period}.",
  low_auth_warning: "Advertencia: Una baja tasa de autenticación puede indicar usuarios inactivos",
  authentication_kpi: "KPI-autenticación",

  
  // FAQ
  faq: "FAQ",
  // frequently_asked_questions: "Preguntas frecuentes",
  faq_subtitle: "Encuentre respuestas a las preguntas más comunes sobre nuestros servicios de autenticación",
  expand_faq: "Expandir {question}",
  collapse_faq: "Contraer {question}",
  // faq_mfa_question: "¿Qué es la autenticación multifactor (MFA)?",
  // faq_mfa_answer: "La autenticación multifactor es un método de seguridad que requiere que los usuarios proporcionen dos o más pruebas de identidad diferentes para acceder a una cuenta. Otenti ofrece varias opciones de MFA, incluyendo SMS, aplicaciones de autenticación y llaves de seguridad físicas.",
  faq_data_protection_question: "¿Cómo protege Otenti los datos de mis usuarios?",
  faq_data_protection_answer: "Otenti utiliza cifrado de extremo a extremo, almacena datos en centros de datos seguros y sigue las mejores prácticas de la industria para la seguridad. Cumplimos con GDPR, CCPA y otras regulaciones importantes de protección de datos.",
  faq_customization_question: "¿Puedo personalizar la interfaz de autenticación?",
  faq_customization_answer: "Sí, Otenti ofrece opciones de personalización completas. Puede adaptar la interfaz a los colores de su marca, modificar los flujos de autenticación y personalizar los mensajes para sus usuarios.",
  faq_uptime_question: "¿Cuáles son las tasas de disponibilidad del servicio?",
  faq_uptime_answer: "Otenti garantiza una disponibilidad del servicio del 99,99%. Mantenemos una infraestructura redundante y monitoreamos nuestros sistemas 24/7 para asegurar una autenticación confiable en todo momento.",
  faq_integration_question: "¿Cómo integro Otenti con mi aplicación existente?",
  faq_integration_answer: "Otenti proporciona SDKs y APIs fáciles de integrar para las principales plataformas y lenguajes de programación. Nuestra documentación detallada y nuestro equipo de soporte técnico lo guiarán a través del proceso de integración.",
  faq_support_question: "¿Qué soporte técnico está disponible?",
  faq_support_answer: "Ofrecemos soporte técnico 24/7 para clientes empresariales, con tiempos de respuesta garantizados según su nivel de servicio. Nuestro equipo de expertos está disponible por correo electrónico, chat y teléfono.",
  faq_user_management_question: "¿Cómo gestiono los usuarios y sus permisos?",
  faq_user_management_answer: "Otenti ofrece un panel de administración completo para gestionar usuarios, roles y permisos. Puede agregar/eliminar usuarios fácilmente, establecer políticas de seguridad y rastrear actividades.",
  faq_pricing_question: "¿Cuáles son las opciones de precios?",
  faq_pricing_answer: "Ofrecemos varios paquetes adaptados a las necesidades de empresas de todos los tamaños, desde startups hasta grandes cuentas. Contacte a nuestro equipo de ventas para obtener un presupuesto personalizado según sus necesidades específicas.",





  // NotFound
  not_found_title: "404 - Página no encontrada",
  not_found_message: "La página que buscas no existe.",
  back_to_home: "Volver al inicio",

  video_tutorials: "Tutoriales en Video",
    integration_tutorials: "Tutoriales de Integración",
    usage_tutorials: "Tutoriales de Uso",
    watch_tutorial: "Ver Tutorial",
    video_not_supported: "Tu navegador no soporta la reproducción de video.",
    tutorial_react_integration_title: "Integrar Otenti con tu Aplicación React",
    tutorial_react_integration_desc: "Guía completa para conectar tu aplicación React con Otenti",
    tutorial_nodejs_auth_title: "Autenticación en Aplicaciones Node.js",
    tutorial_nodejs_auth_desc: "Procedimiento para configurar la autenticación en aplicaciones Node.js",
    tutorial_angular_mfa_title: "Configuración de MFA con Angular",
    tutorial_angular_mfa_desc: "Configuración de autenticación multifactor para proyectos Angular",
    tutorial_user_management_title: "Gestión de Usuarios en Otenti",
    tutorial_user_management_desc: "Aprende cómo gestionar usuarios y permisos en el panel de Otenti",
    tutorial_dashboard_usage_title: "Uso del Panel de Otenti",
    tutorial_dashboard_usage_desc: "Guía para navegar y utilizar el panel de administración de Otenti",
 // Secciones generales
//  video_tutorials: 'Tutoriales en video',
//  integration_tutorials: 'Tutoriales de integración',
//  usage_tutorials: 'Tutoriales de uso',
//  watch_tutorial: 'Ver tutorial',
//  video_not_supported: 'Tu navegador no soporta la reproducción de videos.',
 
 // Títulos de tutoriales de integración
//  tutorial_react_integration_title: 'Tutorial de integración de React',
//  tutorial_nodejs_auth_title: 'Tutorial de autenticación de Node.js',
//  tutorial_angular_mfa_title: 'Tutorial de autenticación MFA con Angular',
 tutorial_vue_integration_title: 'Tutorial de integración de Vue.js',
 tutorial_flutter_integration_title: 'Tutorial de integración de Flutter',
 
 // Descripciones de tutoriales de integración
//  tutorial_react_integration_desc: 'Aprenda a integrar la autenticación Otenti con su aplicación React en unos sencillos pasos.',
//  tutorial_nodejs_auth_desc: 'Configure la autenticación segura en su backend Node.js con nuestra API Otenti.',
//  tutorial_angular_mfa_desc: 'Implemente la autenticación de múltiples factores en su aplicación Angular para mayor seguridad.',
 tutorial_vue_integration_desc: 'Guía completa para integrar la autenticación Otenti en su proyecto Vue.js.',
 tutorial_flutter_integration_desc: 'Configure la autenticación Otenti en su aplicación móvil Flutter en minutos.',
 
 // URLs de videos de integración
 tutorial_react_integration_video: '/videos/otenti-react-integration_es.mp4',
 tutorial_nodejs_auth_video: '/videos/otenti-nodejs-auth_es.mp4',
 tutorial_angular_mfa_video: '/videos/otenti-angular-mfa_es.mp4',
 tutorial_vue_integration_video: '/videos/otenti-vue-integration_es.mp4',
 tutorial_flutter_integration_video: '/videos/otenti-flutter-integration_es.mp4',
 
 // URLs de miniaturas de integración
 tutorial_react_integration_thumbnail: '/thumbnails/react-integration_es.jpg',
 tutorial_nodejs_auth_thumbnail: '/thumbnails/nodejs-auth_es.jpg',
 tutorial_angular_mfa_thumbnail: '/thumbnails/angular-mfa_es.jpg',
 tutorial_vue_integration_thumbnail: '/thumbnails/vue-integration_es.jpg',
 tutorial_flutter_integration_thumbnail: '/thumbnails/flutter-integration_es.jpg',
 
 // Títulos de tutoriales de uso
 tutorial_create_application: 'Crear una nueva aplicación',
 tutorial_add_user: 'Agregar y gestionar usuarios',
 tutorial_add_role: 'Configuración de roles y permisos',
 tutorial_user_management: 'Gestión de cuentas de usuario',
 tutorial_chart_usage: 'Uso de paneles y estadísticas',
 
 // Descripciones de tutoriales de uso
 tutorial_create_application_desc: 'Descubra cómo crear y configurar una nueva aplicación en el portal Otenti.',
 tutorial_add_user_desc: 'Aprenda a agregar usuarios a su aplicación y gestionar su información.',
 tutorial_add_role_desc: 'Guía para configurar roles personalizados y asignar permisos específicos.',
//  tutorial_user_management_desc: 'Gestione eficientemente las cuentas de usuario, sesiones activas y accesos a su aplicación.',
 tutorial_chart_usage_desc: 'Domine el uso de gráficos y paneles para seguir la actividad de su aplicación.',
 
 // URLs de videos de uso
 tutorial_create_application_video: '/videos/otenti-create-application_es.mp4',
 tutorial_add_user_video: '/videos/otenti-add-user_es.mp4',
 tutorial_add_role_video: '/videos/otenti-add-role_es.mp4',
 tutorial_user_management_video: '/videos/otenti-user-management_es.mp4',
 tutorial_chart_usage_video: '/videos/otenti-chart-usage_es.mp4',
 
 // URLs de miniaturas de uso
 tutorial_create_application_thumbnail: '/thumbnails/create-application_es.jpg',
 tutorial_add_user_thumbnail: '/thumbnails/add-user_es.jpg',
 tutorial_add_role_thumbnail: '/thumbnails/add-role_es.jpg',
 tutorial_user_management_thumbnail: '/thumbnails/user-management_es.jpg',
 tutorial_chart_usage_thumbnail: '/thumbnails/chart-usage_es.jpg',

//  Notification
 notification_email_list: "Lista de correos de notificación",
//  close: "Cerrar",
 enter_email_address: "Ingresa la dirección de correo",
 loading_emails: "Cargando correos...",
 no_emails_added: "Aún no se han añadido correos",
 email_required: "Se requiere una dirección de correo",
 invalid_email_format: "Formato de correo inválido",
 email_already_exists: "Este correo ya existe",
 email_added_successfully: "¡Correo añadido con éxito!",
 failed_to_add_email: "No se pudo añadir el correo. Por favor, intenta de nuevo.",
 email_updated_successfully: "¡Correo actualizado con éxito!",
 failed_to_update_email: "No se pudo actualizar el correo. Por favor, intenta de nuevo.",
 email_removed_successfully: "¡Correo eliminado con éxito!",
 failed_to_remove_email: "No se pudo eliminar el correo. Por favor, intenta de nuevo.",
 failed_to_load_emails: "No se pudieron cargar los correos. Por favor, intenta de nuevo.",
 edit_email: "Editar correo",
 save_email: "Guardar correo",
 remove_email: "Eliminar correo",
//  Adminlist
 administrators: "Administradores",
 manage_administrators: "Gestionar administradores",
 view_administrators: "Ver administradores",
 super_admin: "Super Admin",
 full_privileges: "Privilegios completos",
 delete_administrator: "Eliminar administrador",
 action_reserved_for_super_admins: "Acción reservada para super administradores",
 loading_administrators: "Cargando administradores...",
 no_administrators_found: "No se encontraron administradores para esta empresa",
 select_company_to_view_admins: "Por favor, selecciona una empresa para ver sus administradores",
 admin_count: "Número de admins: {count}/3",
 error_loading_administrators: "Error al cargar los administradores",
 administrator_deleted_successfully: "Administrador eliminado con éxito",
 error_deleting_administrator: "Error al eliminar el administrador",
 company_id_missing: "Falta el ID de la empresa",
 only_super_admin_can_delete: "Solo un super administrador puede eliminar administradores",
 cannot_delete_own_account: "No puedes eliminar tu propia cuenta",
 confirm_delete_admin: "¿Estás seguro de que quieres eliminar al administrador {name}?",

//  Page des administrateurs 

  loading_user: "Cargando usuario...",
  error_loading_user: "Error al cargar el usuario. Por favor, intenta de nuevo.",
  admin_management: "Gestión de Administradores",
  create_admin: "Crear un Administrador",
  only_super_admins_can_create: "Solo los superadministradores pueden crear administradores",
  admin_created_successfully: "¡Administrador creado con éxito! 🎉",

  // Ajouter un administrateur
    // add_administrator: "Añadir Administrador",
    close_modal: "Cerrar modal",
    // full_name: "Nombre Completo",
    // email: "Correo Electrónico",
    enter_full_name: "Ingresa el nombre completo",
    // enter_email_address: "Ingresa la dirección de correo",
    full_name_required: "El nombre completo es requerido",
    // email_required: "El correo electrónico es requerido",
    // invalid_email_format: "Formato de correo inválido",
    failed_to_create_admin: "No se pudo crear el administrador",
    // cancel: "Cancelar",
    creating: "Creando...",
    add_administrator_button: "Añadir Administrador",

    // Details des tickets
    
    ticket_details: "Detalles del Ticket",
    refresh_data: "Actualizar Datos",
    data_refreshed: "Datos Actualizados",
    error_loading_ticket: "Error al Cargar el Ticket",
    error_loading_ticket_message: "No se pudieron cargar los detalles del ticket. Por favor, intenta de nuevo más tarde.",
    back_to_tickets: "Volver a los Tickets",
    loading_ticket: "Cargando Ticket",
    please_wait: "Por favor, espera...",
    ticket_content: "Contenido del Ticket",
    discussion: "Discusión",
    no_comments_yet: "Aún no hay comentarios",
    write_your_message: "Escribe tu mensaje",
    support_team: "Equipo de Soporte",
    // pdf_document: "Documento PDF",
    // view: "Ver",
    // download: "Descargar",
    // status_open: "Abierto",
    // status_resolved: "Resuelto",
    last_updated: "Última Actualización",
    // priority_high: "Alta",
    // priority_medium: "Media",
    // priority_low: "Baja",
    // category_technical: "Técnico",
    // category_billing: "Facturación",
    // category_feature: "Funcionalidad",
    // category_other: "Otro",
    created_by: "Creado por",
    company_id: "ID de la Empresa",
    // close: "Cerrar",
    ticket_closed_success: "Ticket Cerrado con Éxito",
    ticket_closed_success_message: "El ticket se ha cerrado con éxito.",
    ticket_reopened: "Ticket Reabierto",
    ticket_reopened_message: "El ticket se ha reabierto con éxito.",
    ticket_status_update_failed: "Fallo en la Actualización del Estado",
    ticket_status_update_failed_message: "No se pudo actualizar el estado del ticket. Por favor, intenta de nuevo.",
    comment_submission_failed: "Fallo en el Envío del Comentario",
    comment_submission_failed_message: "No se pudo enviar el comentario. Por favor, intenta de nuevo.",
    // close_ticket: "Cerrar el Ticket",
    reopen_ticket: "Reabrir el Ticket",
    updating_status: "Actualizando Estado",
    ticket_closed_message: "Este ticket está cerrado. Puedes reabrirlo si es necesario.",

    // logout du header
    
    companyName: "{companyName}",
    applicationName: "{applicationName} Panel de control",
    // loading: "Cargando...",
    user: "Usuario",
    confirmLogout: "Confirmar cierre de sesión",
    logoutQuestion: "¿Realmente quieres cerrar sesión?",
    // cancel: "Cancelar",
    // logout: "Cerrar sesión",
    // dashboard: "Panel de control",
    admin_email_exists: "Este correo electrónico ya existe"
 
  

























































































 








}


 
  
};



